import { defineTranslations, type TranslationRecord } from "@festina-life/core"

import type { en } from "./en"
import { dkConfiguredEnums, dkEnums } from "./enum.dk"

const onlyInDutchLayerForNow = ""
const translationIsInCustomerLayer = ""

export const dk = defineTranslations<TranslationRecord<typeof en>>()({
  ...dkEnums,
  ...dkConfiguredEnums,
  "InstallmentSpecification.amount": "Beløb",
  "InstallmentSpecification.dueDate": "Forfaldsdato",
  "action.addBalancePosting.field.accountType": "Kontotype",
  "action.addBalancePosting.field.amount": "Beløb",
  "action.addBalancePosting.field.balancePostingSpecs": "Specifikation af balancepostering",
  "action.addBalancePosting.field.changeDate": "Ændringsdato",
  "action.addBalancePosting.field.coverKey": "Dækning",
  "action.addBalancePosting.field.fraction": "Procent",
  "action.addBalancePosting.field.fractionBalancePostingSpecs": "Specifikation af procent balancepostering",
  "action.addBalancePosting.field.policeKey": "Police",
  "action.addBalancePosting.field.postingType": "Posteringstype",
  "action.addBalancePosting.title": "Balancepostering",
  "action.addFractionBalancePosting.title": "Procent balancepostering",
  "action.addPayableStop.title": "Tilføj udbetalingsstop",
  "action.addPaymentChannel._type": "Kontotype",
  "action.addPaymentChannel.accountSelection": "Konto",
  "action.addPaymentChannel.addAccount": "Tilføj konto",
  "action.addPaymentChannel.applyDate": "Ikrafttrædelsesdato",
  "action.addPaymentChannel.currencyCode": "Valutakode",
  "action.addPaymentChannel.paymentChannelCriteria": "Betingelser",
  "action.addPaymentChannel.paymentChannelCriteriaElement": "Betingelse",
  "action.addPaymentChannel.title": "Tilføj betalingskanal",
  "action.annotation.title": "Bemærkning",
  "action.changeAddress.button": "Adresse",
  "action.createInvoice.billingMethodType": "Faktura betalingsmetode",
  "action.createInvoice.externalPostingType": "Ekstern posteringstype",
  "action.createInvoice.internalPaymentDueDate": "Intern betalingsfrist",
  "action.createInvoice.invoiceStatus": "Fakturastatus",
  "action.createInvoice.invoiceStrategyId": "Fakturastrategi-ID",
  "action.createInvoice.invoiceType": "Fakturatype",
  "action.createInvoice.lastOperationDate": "Sidste operation dato",
  "action.createInvoice.lastOperationId": "Sidste operations-ID",
  "action.createInvoice.paidAmount": "Betalt beløb",
  "action.createInvoice.paymentDueDate": "Betalingsfrist",
  "action.createInvoice.suspensionDate": "Suspensionsdato",
  "action.createInvoice.suspensionReason": "Suspensionsårsag",
  "action.createInvoice.title": "Ny faktura",
  "action.createPaymentReceiver.applyDate": "Ikrafttrædelsesdato",
  "action.createPaymentReceiver.title": "Opret betalingsmodtager",
  "action.creditPaymentInvoice.paymentDate": "Betalingsdato",
  "action.creditPaymentInvoice.title": "Kreditnota",
  "action.deletePayableStop.title": "Slet udbetalingsstop",
  "action.deletePaymentChannel.input.applyDate": "Ikrafttrædelsesdato",
  "action.deletePaymentChannel.title": "Slet betalingskanal",
  "action.disablePenaltiesInvoice": "Annuller rykkergebyrer på faktura",
  "action.editPayableStop.title": "Rediger udbetalingsstop",
  "action.editPaymentChannel.applyDate": "Ikrafttrædelsesdato",
  "action.editPaymentChannel.channelId": "Betalingskanal",
  "action.editPaymentChannel.title": "Rediger betalingskanal",
  "action.invoicePaymentWithdrawal.disabledDueToManualWriteOffAvailable": "Kan ikke trække en almindelig betaling tilbage, når der findes en manuel afskrivningsbetaling",
  "action.invoicePaymentWithdrawal.disabledDueToWriteOff": "Betaling er blevet afskrevet",
  "action.invoicePaymentWithdrawal.input.newDueDate": "Ny forfaldsdato",
  "action.invoicePaymentWithdrawal.input.nextOperationDate": "Dato for næste opkrævningsoperation",
  "action.invoicePaymentWithdrawal.input.nextOperationId": "ID for næste opkrævningsoperation",
  "action.invoicePaymentWithdrawal.title": "Træk indbetaling tilbage fra opkrævning",
  "action.pauseInvoice": "Sæt faktura på pause",
  "action.payableStop.addText": "Tilføj begrundelse",
  "action.payableStop.applyDate": "Ikrafttrædelsesdato",
  "action.payableStop.payableStopType": "Type",
  "action.payableStop.stopId": "Udbetalingsstop",
  "action.payableStop.text": "Begrundelse",
  "action.resumeInvoice": "Genoptag faktura",
  "action.retirement": "Pensionering",
  "action.retirement.input.retirementDate": "Pensioneringsdato",
  "action.retirement.input.retirementFraction": "Pensioneringsprocent",
  "action.setDefaultPaymentChannel.applyDate": "Ikrafttrædelsesdato",
  "action.setDefaultPaymentChannel.title": "Rediger standard betalingskanal",
  "action.testFullTradeCycle.title": "TESTKOMMANDO - Fuld handelscyklus",
  "actionReasonCode.approvePendingCancellationAlreadyPending": "Annuller godkendelse allerede i gang",
  "actionReasonCode.insufficientAccess": "Utilstrækkelig adgang",
  "actions.addManualInvoice": "Manuel faktura",
  "actions.createInstallmentPlan": "Afdragsordning",
  "actions.setLegalentityStopFlags": "Legalentity: stop",
  "actions.setLifeStopFlags": "Life: stop",
  "actions.setUnitlinkStopFlags": "UnitLink: stop",
  "actions.writeOffInvoice.paymentDate": "Betalingsdato",
  "actions.writeOffInvoice.title": "Afskriv faktura",
  "actions.writeOffInvoice.writeOffCategory": "Afskrivningskategori",
  "activeRecurringMoneyOutVersionDetails.lifeDependent": "Livsafhængig",
  "activeRecurringMoneyOutVersionDetails.moneyOutEndDate": "Udbetaling slutdato",
  "activeRecurringMoneyOutVersionDetails.moneyOutLength": "Udbetalingslængde",
  "activeRecurringMoneyOutVersionDetails.moneyOutStart": "Udbetaling startdato",
  "activeRecurringMoneyOutVersionDetails.moneyOutTaxCode": "Udbetaling skattekode",
  "activeRecurringMoneyOutVersionDetails.moneyOutType": "Udbetalingstype",
  "activeRecurringMoneyOutVersionDetails.payoutAmount": "Udbetaling",
  "activeRecurringMoneyOutVersionDetails.receiverPersonId": "Modtagerens person-ID",
  "activeRecurringMoneyOutVersionDetails.relationshipType": "Forholdstype",
  "addBankAccountModal.title": "Tilføj bankkonto",
  "addFundMergeCommandData.fromDate": "Effektueringsdato",
  "addFundMergeCommandData.fundMerge.date": "Portefølje effektueringsdato",
  "addFundMergeCommandData.fundMergedestinationIsinKey": "Til ISIN nøgle",
  "addFundMergeCommandData.isinKey": "Fra ISIN nøgle",
  "address.addresses": "Adresser",
  "address.city": "By",
  "address.country": "Land",
  "address.field._type": "Type",
  "address.field.abbreviatedCountryName": "Lande kode",
  "address.field.addressCo": "Midlertidig adresse",
  "address.field.addressLine1": "Linje 1",
  "address.field.addressLine2": "Linje 2",
  "address.field.addressLine3": "Linje 3",
  "address.field.city": "By",
  "address.field.country": "Land",
  "address.field.houseNumber": "Nr.",
  "address.field.isValid": "Er gyldig",
  "address.field.numericalCountryCode": "Lande navn",
  "address.field.postalCode": "Postnummer",
  "address.field.relocationDate": "Flyttedato",
  "address.field.relocationInformationReceiveDate": "Modtagelsesdato for flytteoplysninger",
  "address.field.streetName": "Vejnavn",
  "address.postalCode": "Postnummer",
  "addressCard.address1": "Adresse 1",
  "addressCard.address2": "Adresse 2",
  "addressCard.address3": "Adresse 3",
  "addressCard.addressType": "Adressetype",
  "addressCard.city": "By",
  "addressCard.country": "Land",
  "addressCard.postalCode": "Postnummer",
  "addressCard.title": "Adresse",
  "addressLink.field.addressLink": "Adresse",
  "addressLink.field.addressLinks": "Adresser",
  "addressLink.field.addressType": "Adressetype",
  "advancedSearchCard.companyTab": "Firma",
  "advancedSearchCard.internalAndExternalIdLookupTab": "Internt og eksternt ID-opslag",
  "advancedSearchCard.internalIdLookupTab": "Internt ID-opslag",
  "advancedSearchCard.personTab": "Person",
  "agreements.noAgreement": "aftale",
  "agreements.noAppliedEvents.reason": "Vælg en ikke-tilføjet hændelse, for at se data.",
  "agreements.noEventSelected": "hændelse valgt.",
  "agreements.noEventSelected.reason": "Vælg en hændelse for at se data.",
  "agreementsSection.title": "Aftaler",
  "amendEmployerAgreementPolicies.label": "Skift nytegningsprofil til policer",
  "amendEmployerAgreementPolicies.title": "Nytegningsprofil til policer",
  "amendEmployerAgreementPoliciesForm.actionOption": "Ændringstype",
  "amendEmployerAgreementPoliciesForm.adjustSalaryFromContribution": "Automatisk opdatering af løn",
  "amendEmployerAgreementPoliciesForm.applyDate": "Ændringsdato",
  "amendEmployerAgreementPoliciesForm.policyDefaultSelected": "Opret policeramme fra skabelon",
  "amendEmployerAgreementPoliciesForm.subTemplateIdentifier": "Policerammeskabelon",
  "amendEmployerAgreementPolicy.elementLabel": "Skift nytegningsprofil til police",
  "amountCreation.amountPerInstallment": "Beløb pr. afdrag",
  "amountCreation.dueDate": "Forfaldsdato",
  "amountSpecVersionDetails.currentAmount": "Nuværende beløb",
  "amountSpecVersionDetails.currentAmountDocumentation": "Dokumentation af nuværende beløb",
  "amountSpecVersionDetails.fraction": "Procent",
  "amountSpecVersionDetails.fractionDocumentation": "Dokumentation af procent",
  "amountSpecVersionDetails.parameterAmount": "Parameterbeløb",
  "amountSpecVersionDetails.parameterAmountDocumentation": "Dokumentation af parameterbeløb",
  "amountSpecVersionDetails.parameterKey": "Parameternøgle",
  "amountSpecVersionDetails.parameterKeyDocumentation": "Dokumentation af parameternøgle",
  "amountSpecVersionDetails.parameterValue": "Parameterværdi",
  "amountSpecVersionDetails.parameterValueDocumentation": "Dokumentation af parameterværdi",
  "app.title": "Sagsbehandler",
  "appliedEventsTable.itemName": "hændelser",
  "applyScenarioModal.title": "Udfør kladde",
  "applyScenarioModal.warning": "Er du sikker på, at du vil udføre denne kladde? Det vil udføre alle ændringer på engagementet og lukke andre kladder i dette scenarie.",
  "approve": "Godkend",
  "approvePendingCancellation": "Godkend annullering",
  "assignOwnerModal.newOwnerSsnLabel": "Ny ejer",
  "assignOwnerModal.title": "Tildel ejer",
  "balancePostingsFilter.postingTypes": "Posteringstype",
  "balancePostingsFilter.resultLimit": "Maks antal resultater",
  "balancePostingsFilter.transactionTimeIntervalEnd": "Oprettelsesdato til",
  "balancePostingsFilter.transactionTimeIntervalStart": "Oprettelsesdato fra",
  "balancePostingsFilter.valueDateIntervalEnd": "Værdidato til",
  "balancePostingsFilter.valueDateIntervalStart": "Værdidato fra",
  "batch.create": "Opret kørsel",
  "batch.fromTemplate": "Opret kørsel fra skabelon",
  "batchDetailedView.createdBy": "Oprettet af",
  "batchDetailedView.id": "Kørsels-ID:",
  "batchDetailedView.select": "Valgt kørsel:",
  "batchDetailedView.status": "Kørselsstatus:",
  "batchDetailedView.stopBatch": "Stop kørsel",
  "batchError.100max": "Maks. 100",
  "batchError.10max": "Maks. 10",
  "batchError.custom": "Brugerdefineret",
  "batchErrors.download": "Download viste kørsels- og fejloplysninger",
  "batchStatus.activityFrom": "Aktivitet fra",
  "batchStatus.activityTo": "Aktivitet til",
  "batchStatus.batchStatusType": "Status",
  "batchStatus.col.created": "Oprettet",
  "batchStatus.col.duration": "Tid (min)",
  "batchStatus.col.ended": "Færdig",
  "batchStatus.col.entityCount": "Antal entiteter",
  "batchStatus.col.errorCount": "Fejl",
  "batchStatus.col.name": "Navn",
  "batchStatus.col.progressPct": "Status %",
  "batchStatus.col.progressVal": "Status #",
  "batchStatus.col.started": "Igangsat",
  "batchStatus.col.status": "Status",
  "batchStatus.noRestriction": "Ingen begrænsning",
  "batchStatus.specificationType": "Type",
  "birthOrDeathDate.birthdate": "Fødselsdato",
  "birthOrDeathDate.deathdate": "Dødsdato",
  "birthdateChangeButton.birthDate": "Fødselsdato",
  "birthdateChangeButton.birthDateValueDate": "Ikrafttrædelsesdato",
  "birthdateChangeButton.button": "Fødselsdato",
  "bundlingStops.moneyIn.modalTitle": "Fakturaoprettelse stop",
  "cancelInstallmentPlan.description": "Dette vil annullere afdragsordningen og genoptage de oprindelige fakturaer.",
  "cancelInstallmentPlan.title": "Annuller afdragsordning",
  "card.field.informationSource": "Informationskilde",
  "ccInput.column.creationStamp": onlyInDutchLayerForNow,
  "ccInput.column.inputId": onlyInDutchLayerForNow,
  "ccInput.column.valueDate": onlyInDutchLayerForNow,
  "ccLifeInput.title": onlyInDutchLayerForNow,
  "ccStates.column.calcType": onlyInDutchLayerForNow,
  "ccStates.column.creationStamp": onlyInDutchLayerForNow,
  "ccStates.column.inputId": onlyInDutchLayerForNow,
  "ccStates.column.status": "Status",
  "ccStates.column.valid": onlyInDutchLayerForNow,
  "ccStates.column.valueDate": onlyInDutchLayerForNow,
  "ccStates.title": onlyInDutchLayerForNow,
  "ccStatesTable.advancedExcelExport.title": onlyInDutchLayerForNow,
  "ccStatesTable.excelExport.title": onlyInDutchLayerForNow,
  "ccStatesTable.generalConfirmation.title": onlyInDutchLayerForNow,
  "ccStatesTable.generalDescription.title": onlyInDutchLayerForNow,
  "ccStatesTable.lifeConfirmation.title": onlyInDutchLayerForNow,
  "ccStatesTable.lifeDescription.title": onlyInDutchLayerForNow,
  "ccdCalculation.title": onlyInDutchLayerForNow,
  "ccdFilterForm.fromValueDate": onlyInDutchLayerForNow,
  "ccdFilterForm.inputId": onlyInDutchLayerForNow,
  "ccdFilterForm.toValueDate": onlyInDutchLayerForNow,
  "changeCommitmentModalButton.confirm.added": "Tilføjet",
  "changeCommitmentModalButton.confirm.body": "Er du sikker på, at du vil udføre følgende ændringer? Du kan først gøre dette, når simulationen er lykkedes.",
  "changeCommitmentModalButton.confirm.field": "Felt",
  "changeCommitmentModalButton.confirm.noChanges": "Inge ændringer",
  "changeCommitmentModalButton.confirm.removed": "Fjernet",
  "changeCommitmentModalButton.confirm.simulationFailure": "Simulationen fejlede. Du skal udbedre følgende fejl, inden kommandoen kan anlægges:",
  "changeCommitmentModalButton.confirm.simulationPending": "Simulation pågår.",
  "changeCommitmentModalButton.confirm.simulationSuccess": "Simulationen lykkedes.",
  "changeCommitmentModalButton.confirm.title": "Bekræft ændring af engagement",
  "changeCommitmentModalButton.title": "Ændring af engagement og tilstand",
  "changeContributionData.input.applyDate": onlyInDutchLayerForNow,
  "changeContributionData.input.billingFrequency": onlyInDutchLayerForNow,
  "changeContributionData.input.paidInArrears": onlyInDutchLayerForNow,
  "changeContributionData.title": onlyInDutchLayerForNow,
  "changeLegalEntityCommand.confirm.body": "Er du sikker på, at du vil udføre følgende ændringer?",
  "changeLegalEntityCommand.confirm.title": "Bekræft ændring af legalentity",
  "changeTemplateSource.input.applyDate": onlyInDutchLayerForNow,
  "changeTemplateSource.input.templateSourceId": onlyInDutchLayerForNow,
  "changeTemplateSourceCommand.title": onlyInDutchLayerForNow,
  "clearStops.description": "Nedenstående viser, hvilke områder der kan indsættes eller er indsat Stop på",
  "clearStops.doNotCatchUp": "Undlad genberegning",
  "clearStops.employerAgreement.title": "Aftalestop",
  "collCalc.ccCalcType": "Beregningstype",
  "collCalc.details":
    "Denne side viser et sæt afkast i procent og et sæt tilsvarende afkast som beløb for de kollektive opsparinger.\nDisse kommer som resultat af beregninger, der er udført på det kollektive niveau, hvor kollektiv kapitaldistribution under SPR og FPR håndteres, samt justering af ydelser i den kollektive distributionsfase.\nBeregningerne er baseret på input fra pensionsadministrationssystemet og asset manageren (her indlæst fra en Excel-fil), og resultaterne er sendt til pensionsadministrationssystemet.\nNogle af afkasttyperne er: interest protection og excess, micro biometric protection og excess, surplus og supplement. Rækkefølgen af beregninger, deres frekvens og formler er fuldt konfigurerbare.",
  "collCalc.enum.ExternalPayloadType.namingResponse": "",
  "collCalc.exportCalculation": "Eksporter",
  "collCalc.sheet": "Excel-ark",
  "collectivePots.account": "Konto",
  "collectivePots.accountType": "Kontotype",
  "collectivePots.action.addBalancePosting": "Kollektive balanceposteringer",
  "collectivePots.action.editBalancePosting": "Opdater balanceposteringer",
  "collectivePots.balance": "Balance",
  "collectivePots.balancePostings": "Balanceposteringer",
  "collectivePots.column.balance": "Balance",
  "collectivePots.column.delta": "Delta",
  "collectivePots.column.endDate": "Slutdato",
  "collectivePots.column.startDate": "Startdato",
  "collectivePots.description": "Beskrivelse",
  "collectivePots.draftWorkPads": "Workpadkladder",
  "collectivePots.netAmount": "Nettobeløb",
  "command.isScenario": "Scenarie",
  "commandData.approvedBy": "Godkendt af",
  "commandData.cancel": "Annuller kommando",
  "commandData.cancel.body": "Annullering af en kommando vil rulle alle dens ændringer tilbage. Inden du bekræfter skal du sikre dig, at dette er hvad du ønsker.",
  "commandData.cancel.title": "Er du sikker på, at du vil annullere: {title}?",
  "commandData.cancelledApprovedBy": "Annullering godkendt af",
  "commandData.cancelledBy": "Annulleret af",
  "commandData.createdBy": "Oprettet af",
  "commandData.description": "Et lavere tal angiver en højere prioritet.",
  "commandData.notAllowedToApproveOwnCommands": "Du har ikke tilladelse til at godkende dine egne kommandoer.",
  "commandData.onlyScenarioCommandAllowed": "Det er kun muligt at udføre handlinger på kommandoer oprettet i et scenarie",
  "commandData.priority": "Prioritet",
  "commandData.reasonForBeingUnapplied": "Årsag til ikke-anvendelse",
  "commandData.reasonForBeingUnapplied.approvalPending": "Godkendelse afventer",
  "commandData.reasonForBeingUnapplied.cancelApprovalPending": "Annuller godkendelse afventer",
  "commandData.reasonForBeingUnapplied.futureApplyDate": "Fremtidig ikrafttrædelsesdato",
  "commandData.reasonForBeingUnapplied.missingPersons": "Manglende personer",
  "commandEventsGraph.tooltip.around": "Omkring",
  "commandEventsGraph.tooltip.from": "Fra",
  "commandEventsGraph.tooltip.to": "Til",
  "commandExclustionToggle.tooltip": "Inkluder kommando når scenariet udføres",
  "commandModalButton.deflateCommitmentVersion": "Inflationskorrigeret simulering",
  "commandModalButton.hoverAlertToSeeErrorDetails": "Hold musen over advarslen for at se fejldetaljer.",
  "commandModalButton.simulate": "Simuler",
  "commandModalButton.unableToEditToDoCriticalError.body": "Slet venligst og opret kommandoen igen.",
  "commandModalButton.unableToEditToDoCriticalError.title": "Portalen kan ikke understøtte redigering på grund af en kritisk fejl.",
  "commandModalButton.viewError.body": "Handlinger er stadig tilgængelige på trods af fejlen. Nedenfor kan du se alle tilgængelige data for denne kommando.",
  "commandModalButton.viewError.title": "Der opstod en uventet fejl",
  "commandPalette.download": "Download",
  "commandPalette.group.favourites.tooltip.hide": "Skjul favoritter i denne gruppe",
  "commandPalette.group.favourites.tooltip.show": "Vis favoritter i denne gruppe",
  "commandPalette.group.unauthorized.tooltip.hide": "Skjul uautoriserede i denne gruppe",
  "commandPalette.group.unauthorized.tooltip.show": "Vis uautoriserede i denne gruppe",
  "commandPalette.group.warnings.tooltip.hide": "Skjul advarsler i denne gruppe",
  "commandPalette.group.warnings.tooltip.show": "Vis advarsler i denne gruppe",
  "commandPalette.placeholder": "Begynd indtastning...",
  "commandTable.column.appliedStatus": "Anvendt",
  "commandTable.column.applyDate": "Ikrafttrædelsesdato",
  "commandTable.column.approvedBy": "Godkendt af",
  "commandTable.column.cancelApprovedBy": "Annullering godkendt af",
  "commandTable.column.cancelledBy": "Annulleret af",
  "commandTable.column.cancelledStatus": "Annulleret",
  "commandTable.column.cancelledTime": "Annulleret tid",
  "commandTable.column.commandTemplateId": "Trin",
  "commandTable.column.createdBy": "Oprettet af",
  "commandTable.column.createdTime": "Oprettelsesdato",
  "commandTable.column.expectedApplyDate": "Forventet oprettelsesdato",
  "commandTable.column.information": "Information",
  "commandTable.column.rolledBackStatus": "Rullet tilbage",
  "commandTable.column.status": "Status",
  "commandTable.column.unappliedCommand": "Ikke-tilføjet kommando",
  "commandTable.title": "Hændelser",
  "commitment.dateSelector.label": "Vis engagement pr.",
  "commitment.layout.navigation.covers": "Dækninger",
  "commitment.layout.navigation.events": "Begivenheder",
  "commitment.layout.navigation.home": "Hjem",
  "commitment.layout.navigation.moneyInInvoices": "Opkrævninger",
  "commitment.layout.navigation.paymentReceiver": "Betalingsmodtager",
  "commitment.layout.navigation.paymentsIn": "Indbetaling",
  "commitment.layout.navigation.paymentsOut": "Udbetalinger",
  "commitment.layout.navigation.personInformation": "Personoplysninger",
  "commitment.layout.navigation.policy": "Policer",
  "commitment.layout.navigation.portfolio": "Portefølje",
  "commitment.layout.navigation.relatedCommitments": "Relaterede engagementer",
  "commitment.layout.navigation.scenarios": "Scenarier",
  "commitment.layout.navigation.workbench": "Detaljer",
  "commitmentOverview.information.retirementCard.retirementDate": "Pensioneringsdato",
  "commitmentOverview.information.retirementCard.retirementFraction": "Pensioneringsprocent",
  "commitmentOverview.information.retirementCard.title": "Pensioneringsdata",
  "commitmentRegressionSpecification.commitmentRegressionCompareDefinitionTemplateId": "Skabelon-ID til sammenligning af engagement (CommitmentRegressionCompareDefinition)",
  "commitmentRegressionSpecification.coverRegressionCompareDefinitionTemplateId": "Skabelon-ID til sammenligning af dækninger (CoverRegressionCompareDefinition)",
  "commitmentRegressionSpecification.fromDate": "Genberegning fra",
  "commitmentRegressionSpecification.policyRegressionCompareDefinitionTemplateId": "Skabelon-ID til sammenligning af policer (PolicyRegressionCompareDefinition)",
  "commitmentScenario.form.newFieldInfo": "Den angivne titel findes ikke og vil resultere i en ny oprettelse",
  "commitmentScenario.form.scenario": "Scenario",
  "commitmentScenario.form.variant": "Variant",
  "commitmentScenario.modal.add": "Tilføj til scenario: {scenarioTitle}, {variantTitle}",
  "commitmentScenario.modal.addUnknown": "Tilføj til scenario",
  "commitmentScenario.modal.create": "Opret/tilføj til scenario",
  "commitmentSource.commitmentTime": "Engagement tid {commitmentTime}",
  "commitmentStart.startDate": "Kunde siden {startDate}",
  "commitmentStatus.status": "Engagement status",
  "company.layout.navigation.agreements": "Aftaler",
  "company.layout.navigation.home": "Hjem",
  "company.layout.navigation.legalentity": "Firmaoplysninger",
  "company.layout.navigation.moneyInInvoices": "Fakturaer",
  "companyInformationCard.endDate": "Slutdato",
  "companyInformationCard.foundationDate": "Startdato",
  "companyInformationCard.name": "Navn",
  "companyInformationCard.title": "Firmaoplysninger",
  "companySearchForm.similarName": "Lignende navn",
  "companySearchResultsCard.column.addresses": "Adresser",
  "companySearchResultsCard.column.externalId": "CVR",
  "companySearchResultsCard.column.internalId": "Internt ID",
  "companySearchResultsCard.column.name": "Navn",
  "companySection.endDate": "Slutdato",
  "companySection.externalId": "CVR",
  "companySection.foundationDate": "Startdato",
  "companySection.internalId": "Internt ID",
  "component.legalentity": "Legalentity",
  "component.life": "Life",
  "component.moneyout": "Money out",
  "component.unitlink": "Unitlink",
  "contributionData.billingFrequency": "Betalingsfrekvens",
  "contributionData.paidInArreas": "Bagudbetalt",
  "copyVariantModal.commands": "Kommandoer der kopieres",
  "copyVariantModal.copyNewVariant": "Make new copy: {variantTitle}",
  "copyVariantModal.copyToVariant": "Copy to: {variantTitle}",
  "copyVariantModal.noCommands": "Ingen kommandoer at kopiere.",
  "copyVariantModal.selectVariant": "Variant name to copy to",
  "count": "Antal: {count}",
  "cover.riskEndDate": "Slutdato",
  "coverColumn.benefitEnd": "Ydelse udløb",
  "coverColumn.benefitParameter": "Evt. ydelsesgrundlag",
  "coverColumn.billingBalance": "Opkrævningssaldo",
  "coverColumn.calculatedBenefit": "Ydelse",
  "coverColumn.claimBalance": "Krav-balance",
  "coverColumn.coInsured": "Medforsikrede",
  "coverColumn.contribFraction": "Procent",
  "coverColumn.contribPriority": "Prioritet",
  "coverColumn.coverKey": "Dækning",
  "coverColumn.coverProductType": "Dækningstype",
  "coverColumn.coverStatus": "Status",
  "coverColumn.moneyOutEndDate": "Slutdato",
  "coverColumn.moneyOutType": "Type",
  "coverColumn.originalExternalsecondaryId": "Forsikringstager",
  "coverColumn.premiumAmount": "Årlig prm",
  "coverColumn.premiumPct": "Præmie-pct",
  "coverColumn.productName": "Produktnavn",
  "coverColumn.receiverPerson": "Modtager",
  "coverColumn.relatedToCoverKey": "Relateret til dækning",
  "coverColumn.riskBenefitAmount": "Årlig ydelse",
  "coverColumn.riskBenefitPct": "Ydelses-pct",
  "coverColumn.riskBenefitTriggers": "Dækning ved",
  "coverColumn.riskEndDate": "Slutdato",
  "coverColumn.savingsBalance": "Balance",
  "coverColumn.taxCode": "Skattekode",
  "coverColumn.unitlinkStatus": "Unitlink-status",
  "coverColumn.yearlyPremiumParameter": "Evt. præmiegrundlag",
  "coverDetails.activeRecurringMoneyOutVersion": "Aktiv gentagende udbetaling",
  "coverDetails.billingFrequency": "Betalingsfrekvens",
  "coverDetails.coverKey": "Dækning",
  "coverDetails.coverProductType": "Dækningsprodukttype",
  "coverDetails.coverStatus": "Dækningsstatus",
  "coverDetails.fromDate": "Fra",
  "coverDetails.insured": "Forsikrede",
  "coverDetails.moneyInTaxCode": "Indbetalingsskattekode",
  "coverDetails.originalExternalsecondaryId": "Oprindeligt eksternt sekundært ID",
  "coverDetails.policyKey": "Policenummer",
  "coverDetails.premium": "Præmie",
  "coverDetails.sortPriority": "Sorteringsprioritet",
  "coverDetails.tenantSubGroup": "Selskabsundergruppe",
  "coverDetails.title": "Dækningsdetaljer",
  "coverDetails.unitlinkStatus": "Unitlink-status",
  "coverDetails.yearlyPremium": "Årlig præmie",
  "coverDetailsModal.title": "Dækningsdetaljer",
  "coverLayerVersion.benefit": "Ydelse",
  "coverLayerVersion.name": "Navn",
  "coverLayerVersion.tariffId": "Takst-ID",
  "coverList.activeRiskCovers": "Udbetalende risikodækninger",
  "coverList.activeSavingsCovers": "Udbetalende opsparinger",
  "coverList.balancePostings": "Balanceposteringer",
  "coverList.riskCoverType": "Risiko",
  "coverList.riskCovers": "Risikodækninger",
  "coverList.savingsCoverType": "Opsparing",
  "coverList.savingsCoverWithBalance": "Opsparingsdækninger med saldo",
  "coverList.savingsCovers": "Opsparingsdækninger",
  "coverSimulation.title": "Dækninger",
  "coversSimulation.aggregated": "Aggregeret",
  "coversSimulation.detailedView": "Detaljeret visning",
  "coversTable.column.balance": "Balance",
  "coversTable.column.beneficiaryEndAge": "til {age}",
  "coversTable.column.benefit": "Ydelse",
  "coversTable.column.benefitEnd": "Ydelse udløb",
  "coversTable.column.coverKey": "Dækning",
  "coversTable.column.coverProductType": "Produkttype",
  "coversTable.column.coverStatus": "Status",
  "coversTable.column.coverType": "Dækning ved",
  "coversTable.column.insured": "Forsikrede",
  "coversTable.column.lifeInsuranceEvents": "Forsikringsbegivenheder",
  "coversTable.column.moneyOutLength": "i {years}",
  "coversTable.column.moneyOutType": "Udbetalingstype",
  "coversTable.column.policyKey": "Police",
  "coversTable.column.riskEndDate": "Slutdato",
  "coversTabsCard.allCovers": "Alle dækninger",
  "createAgreement.applyDate": "Ikrafttrædelsesdato for aftalen",
  "createAgreement.commitmentTemplateId": "Engagement-skabelon",
  "createAgreement.companyId": "CVR nummer",
  "createAgreement.contributionData": "Bidragsdata",
  "createAgreement.employerAgreementId": "Firmaaftale-ID",
  "createAgreement.name": "Navn",
  "createAgreement.templateSourceId": "Rammeaftale",
  "createAgreement.title": "Ny aftale",
  "createAgreement.toDate": "Til dato",
  "createCommitmentModalButton.template": "Skabelon",
  "createCommitmentModalButton.title": "Nyt engagement",
  "createCompany.address": "Adresse",
  "createCompany.addresses": "Adresser",
  "createCompany.button": "Nyt firma",
  "createCompany.companyId": "Firma-ID",
  "createCompany.name": "Navn",
  "createInstallmentPlan.installment": "Afdrag {index}",
  "createInstallmentPlan.installmentTotal": "Afdrag total",
  "createInstallmentPlan.installments": "Afdrag",
  "createInstallmentPlan.invoiceTotal": "Faktura total",
  "createInstallmentPlan.invoices": "Fakturaer",
  "createInstallmentPlan.remainingAmount": "Restbeløb",
  "createInstallmentPlan.title": "Afdragsordning",
  "createInstallmentPlanform.creationMethod.byAmount": "Angiv beløb",
  "createInstallmentPlanform.creationMethod.byInstallments": "Antal terminer",
  "createInstallmentPlanform.creationMethod.manual": "Manuelt",
  "createInvoiceElementsInvoice.aggregatedAmount": "Sum",
  "createInvoiceElementsInvoice.negative": "Negativ",
  "createInvoiceElementsInvoice.numAmounts": "Antal",
  "createInvoiceElementsInvoice.positive": "Positiv",
  "createInvoiceElementsInvoice.title": "Opret faktura fra fakturaelementer",
  "createInvoiceElementsInvoice.total": "Total",
  "createLegalEntityModalButton.button": "Ny kunde",
  "createLegalEntityModalButton.externalId": "Eksternt ID",
  "createLegalEntityModalButton.pseudoExternalId": "Pseudo-CPR-nummer",
  "createPersonCommandData.birthdate": "Fødselsdato",
  "createPersonCommandData.firstName": "Fornavn",
  "createPersonCommandData.gender": "Køn",
  "createPersonCommandData.initials": "Initialer",
  "createPersonCommandData.lastName": "Efternavn",
  "createPersonCommandData.nationality": "Nationalitet",
  "createPolicyModalButton.fromDate": "Startdato",
  "createPolicyModalButton.policyTemplateId": "Skabelon-ID",
  "createPolicyModalButton.title": "Ny police",
  "darkModeSwitcher.label": "Tema",
  "deathButton.deathDate": "Dødsfaldsdato",
  "deathButton.title": "Dødsfald",
  "deathClaims.addDeathClaim": "Dødsfaldsudbetaling",
  "deathClaims.benefit": "Ydelse",
  "deathClaims.covers": "Dækninger",
  "deathClaims.policy": "Police",
  "deathClaims.receiverName": "Modtager",
  "deathClaims.receivers": "Begunstigede",
  "deathClaims.relationshipType": "Relations",
  "deathClaims.relationshipType.receiver": "Forhold med afdøde",
  "deathClaims.senderName": "Afsender",
  "deathClaimsCard.title": "Efterladtepension",
  "declinePendingCancellation": "Slet annulleringsanmodning",
  "deleteCommitmentSourceExternalPayloadModalButton.title": "Slet ekstern engagement payload",
  "deleteScenarioModal.title": "Slet scenarie",
  "deleteScenarioModal.warning": "Er du sikker på, at du vil slette scenariet?",
  "deleteVariantModal.title": "Slet kladde",
  "deleteVariantModal.warning": "Er du sikker på, at du vil slette scenariekladden?",
  "disabilityLane.fallbackTitle": "Invaliditet",
  "disablePenaltiesInvoice.field.disableFromDate": "Gyldig fra",
  "divorceButton.endDate": "Skilsmissedato",
  "divorceButton.title": "Skilsmisse",
  "download.commitmentRegression.title": "Download engagementkilde regression",
  "download.commitmentSource.title": "Download engagementkilde (.json)",
  "download.employerAgreementSource.title": "Download arbejdsgiveraftalekilde (.json)",
  "download.exportCommitmentButton.button": "Engagement (.xlsm)",
  "download.exportCommitmentButton.title": "Eksporter engagement (.xlsm)",
  "download.exportEmployerAgreement.button": "Firmaaftale (.xlsm)",
  "download.exportGlPostingsOriginalButton.title": "Download GL-posteringer (original)",
  "download.exportInvoice.button": "Opkrævning (.xlsm)",
  "download.exportMoneyInButton.title": "Eksporter indbetalinger (.xlsm)",
  "download.exportMoneyOutButton.title": "Eksporter udbetalinger (.xlsm)",
  "download.exportPersonSourceExcelSheet.button": "Personkilde (.xlsm)",
  "download.exportPortfolioButton.button": "Portefølje (.xlsm)",
  "download.exportReconciliationReportButton.title": "Eksporter afstemningsrapport",
  "download.legalEntitySource.button": "Personkilde (.json)",
  "draftWorkPad.approve.description": "Årsag",
  "draftWorkPad.approve.title": "Godkendelse",
  "draftWorkPad.approved": "Godkendt",
  "draftWorkPad.creationStamp": "Dato for oprettelse",
  "draftWorkPad.creationUserId": "Bruger-ID",
  "draftWorkPad.delete.description": "Årsag",
  "draftWorkPad.delete.title": "Sletning",
  "draftWorkPad.deleted": "Slettet",
  "draftWorkPad.includeDeleted": "Inkluder sletning",
  "draftWorkPad.undelete.description": "Fortryd sletning",
  "draftWorkPad.undelete.title": "Fortrydelse af sletning",
  "editBankAccountModal.title": "Rediger bankkonto",
  "editFundCommandSelectionModal.fraction": "Procent",
  "editFundCommandSelectionModal.fund": "Fond",
  "editFundCommandSelectionModal.isinKey": "Fond",
  "editPartitionCommandSelectionModal.fraction": "Procent",
  "editPartitionCommandSelectionModal.partition": "Partition",
  "editPartitionCommandSelectionModal.profileType": "Profiltype",
  "editPortfolioModalButton.title": "Avanceret ændring af portefølje",
  "editScenarioModal.input.title": "Navn",
  "editScenarioModal.titleEdit": "Rediger scenarie",
  "editScenarioModal.titleNew": "Opret scenarie",
  "editScenarioVariantModal.input.personBirthdate": "Fødselsdato",
  "editScenarioVariantModal.input.title": "Navn",
  "editScenarioVariantModal.titleEdit": "Rediger kladde",
  "editScenarioVariantModal.titleNew": "Opret kladde",
  "employerAgreement.agreementName": "Firmaaftalenavn",
  "employerAgreement.companyId": "Aftalepart",
  "employerAgreement.contribution.billingFrequency": "Betalingsfrekvens",
  "employerAgreement.contribution.paidInArreas": "Bagudbetalt",
  "employerAgreement.contribution.title": "Bidrag",
  "employerAgreement.cover.benefit": "Standardydelse",
  "employerAgreement.cover.coverId": "Dæknings-ID",
  "employerAgreement.cover.events": "Begivenheder",
  "employerAgreement.cover.maxBenefit": "Maks. ydelse",
  "employerAgreement.cover.minBenefit": "Min. ydelse",
  "employerAgreement.cover.selected": "Valgt som standard",
  "employerAgreement.cover.type": "Type",
  "employerAgreement.covers.title": "Dækninger",
  "employerAgreement.employeeAgreementTemplateId": "Rammeaftale",
  "employerAgreement.employerAgreementId": "Firmaaftale-ID",
  "employerAgreement.fromDate": "Oprettelsesdato",
  "employerAgreement.moneyIn.amount": "Beløb",
  "employerAgreement.moneyIn.isPaid": "Betalt",
  "employerAgreement.moneyIn.payer": "Betaler CVR",
  "employerAgreement.moneyIn.person": "Person",
  "employerAgreement.moneyIn.valueDateIntervalEnd": "Periode sidste dato",
  "employerAgreement.moneyIn.valueDateIntervalStart": "Periode første dato",
  "employerAgreement.name": "Firmaaftalenavn",
  "employerAgreement.period": "Periode",
  "employerAgreement.policyDetailsCard.defaultSelected": "Valgt som standard",
  "employerAgreement.policyDetailsCard.template": "Policerammeskabelon",
  "employerAgreement.policyDetailsCard.title": "Policedetaljer",
  "employerAgreement.status": "Status",
  "employerAgreement.title": "Arbejdsgiveraftale",
  "employerAgreementsTable.title": "Firmaaftale",
  "employment.actions.details": "Detaljer",
  "employment.actions.salaryPeriods": "Lønperioder",
  "employment.agreementId": "Aftale",
  "employment.benefitBase": "Ydelsesbasis",
  "employment.billingFrequency": "Opkrævningsfrekvens",
  "employment.command.modal.agreementId": "Firmaaftale-ID",
  "employment.command.modal.changeDate": "Ændringsdato",
  "employment.command.modal.commitmentId": "Engagement-ID",
  "employment.command.modal.companyName": "Firmanavn",
  "employment.command.modal.employmentId": "Beskæftigelses-ID",
  "employment.command.modal.endDate": "Slutdato",
  "employment.details.title": "Ansættelsesdetaljer",
  "employment.employerId": "Arbejdsgiver-ID",
  "employment.employmentEnd": "Slutdato",
  "employment.employmentId": "Ansættelsesforhold",
  "employment.employmentStart": "Startdato",
  "employment.movement.premium": "Præmie",
  "employment.movement.salary": "Løn",
  "employment.movement.salaryPartTimePct": "Deltidsprocent",
  "employment.movement.salaryPeriodEnd": "Lønperiodeslut",
  "employment.movement.salaryPeriodStart": "Lønperiodestart",
  "employment.paidInArrears": "Bagudbetalt",
  "employment.partTimePercentage": "Deltidsprocent",
  "employment.title": "Ansættelsesforhold",
  "employment.yearlyPensionableSalary": "Indberettet pensionsgivende løn",
  "employment.yearlySalary": "Årlig løn",
  "employmentOverview.billingFrequency": "{frequency} betaling",
  "employmentRow.details": "Detaljer",
  "enum.ActionOption.CreateEmployerAgreementPolicySelectionData": "Opret police",
  "enum.ActionOption.DeleteEmployerAgreementPolicySelectionData": "Slet police",
  "enum.ActionOption.UpdateEmployerAgreementPolicySelectionData": "Opdater police",
  "enum.ActionWarningCode.aboveEligibleAge": "Over berettiget alder",
  "enum.ActionWarningCode.alreadyApplied": "Allerede anlagt",
  "enum.ActionWarningCode.expectedCommitmentStatus": "Forventet engagementstatus",
  "enum.ActionWarningCode.expectedDateAfter": "Forventet dato efter",
  "enum.ActionWarningCode.hasActivePartner": "Har aktiv partner",
  "enum.ActionWarningCode.hasField": "Har",
  "enum.ActionWarningCode.missingField": "Mangler",
  "enum.ActionWarningCode.noActivePartner": "Ingen aktiv partner",
  "enum.ActionWarningCode.noPartner": "Ingen partner",
  "enum.ActionWarningCode.notScenario": "Ikke scenarie",
  "enum.ActionWarningCode.unexpectedCommitmentStatus": "Uventet engagementstatus",
  "enum.ActionWarningCode.unexpectedInvoiceStatus": "Uventet fakturastatus",
  "enum.ActionWarningCode.unexpectedPolicyStatus": "Uventet policestatus",
  "enum.CommandTemplateId.AddBalancePostingsCommand": "Tilføj balancepostering",
  "enum.CommandTemplateId.DeathClaimOrphanCommand": "Waisenkrav",
  "enum.CommandTemplateId.HandleMoneyInCommand": "Håndter indbetalinger",
  "enum.CommandTemplateId.NewPolicyCommand": "Ny police",
  "enum.CommandTemplateId.NlValueTransferInCommand": "Overførsel ind",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStep": "Frivillig indbetaling slut",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStepV2": "Frivillig indbetaling slut",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStep": "Frivilling indbetaling start",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStepV2": "Frivilling indbetaling start",
  "enum.CommandTemplateId.NlVoluntaryContributionUpdateStep": "Opdater frivilling indbetaling",
  "enum.CommandTemplateId.RetirementCommand": "Pensioneringskommando",
  "enum.Persona.AdvisorAllan": "Advisor Allan",
  "enum.Persona.AgreementAnnie": "Agreement Annie",
  "enum.Persona.CommitmentCamilla": "Commitment Camilla",
  "enum.Persona.DeathDennis": "Death Dennis",
  "enum.Persona.FrontOfficeFrida": "Front Office Frida",
  "enum.Persona.HealthHeather": "Health Heather",
  "enum.Persona.MoneyInMark": "Money In Mark",
  "enum.Persona.MoneyOutMichael": "Money Out Michael",
  "enum.Persona.RetirementRita": "Retirement Rita",
  "enum.Persona.TaskListTeddy": "Task List Teddy",
  "enum.PolicyType.PLACEHOLDER": translationIsInCustomerLayer,
  "enum.PostingDimensions.dim1": "Dim 1",
  "enum.PostingDimensions.dim2": "Dim 2",
  "enum.PostingDimensions.dim3": "Dim 3",
  "enum.PostingDimensions.dim4": "Dim 4",
  "enum.PostingDimensions.dim5": "Dim 5",
  "enum.PostingDimensions.dim6": "Dim 6",
  "enum.PostingDimensions.dim7": "Dim 7",
  "enum.PostingDimensions.dim8": "Dim 8",
  "enum.PostingDimensions.key1": "Key 1",
  "enum.PostingDimensions.key2": "Key 2",
  "enum.PostingDimensions.key3": "Key 3",
  "enum.PostingDimensions.key4": "Key 4",
  "enum.SearchCategories.agreement": "Aftale",
  "enum.SearchCategories.changes": "Ændringer",
  "enum.SearchCategories.collectiveCalculations": "Kollektiv beregning",
  "enum.SearchCategories.common": "Person/Firma håndtering",
  "enum.SearchCategories.company": "Firma",
  "enum.SearchCategories.contributionHandling": "Bidragshåndtering",
  "enum.SearchCategories.death": "Død",
  "enum.SearchCategories.disabilityAndSickness": "Invaliditet og sygdom",
  "enum.SearchCategories.disbursement": "Udbetaling",
  "enum.SearchCategories.divorceSeparation": "Skilsmisse og separation",
  "enum.SearchCategories.download": "Download",
  "enum.SearchCategories.employment": "Ansættelse",
  "enum.SearchCategories.externalPayload": "Ekstern payload",
  "enum.SearchCategories.favourites": "Favoritter",
  "enum.SearchCategories.health": "Helbred",
  "enum.SearchCategories.incomingPayment": "Indbetaling",
  "enum.SearchCategories.investmentFundHandling": "Håndtering af investeringsfonde",
  "enum.SearchCategories.invoiceHandling": "Fakturahåndtering",
  "enum.SearchCategories.marriageCohabitantChildren": "Ægteskab, samliv og børn",
  "enum.SearchCategories.migration": "Migration",
  "enum.SearchCategories.new": "Ny",
  "enum.SearchCategories.outgoingPayment": "Udbetaling",
  "enum.SearchCategories.person": "Person",
  "enum.SearchCategories.policy": "Police",
  "enum.SearchCategories.portfolio": "Portefølje",
  "enum.SearchCategories.portfolioHandling": "Porteføljehåndtering",
  "enum.SearchCategories.pretend": "Scenarie specifikt",
  "enum.SearchCategories.retirement": "Pensionering",
  "enum.SearchCategories.specialCommands": "Specielle kommandoer",
  "enum.SearchCategories.stop": "Stop",
  "enum.SearchCategories.tax": "Skat",
  "enum.SearchCategories.tenant": "Selskab",
  "enum.SearchCategories.termination": "Ophør",
  "enum.SearchCategories.transfers": "Overførsler",
  "enum.SearchGroup.command": "Kommando",
  "enum.SearchGroup.navigation": "Navigation",
  "enum.SearchGroup.recent": "Seneste",
  "enum.SearchGroup.settings": "Indstillinger",
  "enum.SearchGroup.tenant": "Selskab",
  "enum.ShortEmployerAgreementStatus.active": "A",
  "enum.ShortEmployerAgreementStatus.future": "F",
  "enum.ShortEmployerAgreementStatus.terminated": "O",
  "enum.Step.AddBalancePostingsStep": "Manuelt opdateret kapital",
  "enum.Step.AddFundMergeStep": "Tilføj fondssammensmeltning",
  "enum.Step.AddInsuredStep": "Personoplysninger tilføjet",
  "enum.Step.AddMigrationStepV1": "Migrer",
  "enum.Step.AddMigrationStepV3": "Migrer",
  "enum.Step.AddMigrationStepV4": "Migrer",
  "enum.Step.AddPayableStopStep": "Tilføj udbetalingsstop",
  "enum.Step.AddPaymentChannelStep": "Tilføj betalingskanal",
  "enum.Step.AddRelatedPersonStep": "Relateret person tilføjet",
  "enum.Step.AddUpaFileStep": "UPA fil tilføjet",
  "enum.Step.AddressChangeStep": "Opdater adresse",
  "enum.Step.AdvanceMonthStep": "Månedlig fremregning",
  "enum.Step.AmendCoversSelectionStep": "Ændring af dækning",
  "enum.Step.AmendEmployerAgreementCoversStep": "Ændring af dækninger",
  "enum.Step.AmendEmployerAgreementPoliciesStep": "Ændring af policer",
  "enum.Step.BirthDateChangeStep": "Skift fødselsdato",
  "enum.Step.ChangeAgreementStep": "Rediger aftale",
  "enum.Step.ChangeCommitmentAndStateStep": "Manuelt opdateret",
  "enum.Step.ChangeCommitmentTemplateSourceStep": "Skift kilde til engagementskabelon",
  "enum.Step.ChangeContributionDataStep": "Skift bidragsdata",
  "enum.Step.ChangeDataChannelStep": "Skift data kanal",
  "enum.Step.ChangeNameStep": "Rediger navn",
  "enum.Step.ChangePartnerIdStep": "Rediger partner-ID",
  "enum.Step.ChangeRiskProfileStep": "Rediger risikoprofil",
  "enum.Step.ChangeTemplateSourceStep": "Rediger kilde til skabelon",
  "enum.Step.CloseCommitmentStep": "Kundeforhold lukket",
  "enum.Step.CloseSubPortfolio": "Luk dækninger",
  "enum.Step.CloseSubPortfolioTrade": "Luk dækninger (handel)",
  "enum.Step.CreateAgreementStep": "Opret aftale",
  "enum.Step.CreateCompanyStep": "Opret firma",
  "enum.Step.CreateEmployment": "Nyt ansættelsesforhold tilføjet",
  "enum.Step.CreateInvoiceStep": "Opret faktura",
  "enum.Step.CreatePaymentReceiverStep": "Opret betalingsmodtager",
  "enum.Step.CreatePersonMigrationV3Step": "Ny person-migrering",
  "enum.Step.CreatePersonStep": "Opret person",
  "enum.Step.DeletePayableStopStep": "Slet udbetalingsstop",
  "enum.Step.DeletePaymentChannelStep": "Slet betalingskanal",
  "enum.Step.DisablePenaltiesInvoiceStep": "Annuller rykkergebyr",
  "enum.Step.EditPayableStopStep": "Rediger udbetalingsstop",
  "enum.Step.EditPaymentChannelStep": "Rediger betalingskanal",
  "enum.Step.EndPartnerMigrationV3Step": "Afslut partnermigrering",
  "enum.Step.EndPartnerMigrationV4Step": "Afslut partnermigrering",
  "enum.Step.EndPartnershipStep": "Afslut partnerskab",
  "enum.Step.ExternalIdChangeStep": "Skift eksternt ID",
  "enum.Step.GenderChangeStep": "Skift køn",
  "enum.Step.HandleAnnuityMoneyOutStep": "Udbetaling af løbende ydelser",
  "enum.Step.HandleCoverEndStep": "Dækning udløbet",
  "enum.Step.HandleDeathBeneficiaryStep": "Dødsfaldsudbetaling tilføjet",
  "enum.Step.HandleLumpSumMoneyOut": "Håndter engangsbeløb til udbetaling",
  "enum.Step.HandlePolicyPostponeStep": "Udskyd pensionering",
  "enum.Step.HandleTemplateChangeStep": "Håndter skift af skabelon",
  "enum.Step.HandleTriggerMessageStep": "Ekstern trigger udført",
  "enum.Step.HandleUnitlinkClosedPortfolioStep": "Håndter unitlink luk portefølje",
  "enum.Step.HandleWopMoneyInStep": "Håndter præmiefritagelsesbeløb",
  "enum.Step.HandleYearStartStep": "Årskørsel",
  "enum.Step.InsuredPersonDeathUpdateBalanceStep": "Dækninger transformeret ved død",
  "enum.Step.InsuredPersonStateParentStep": "Ændring af forsikredes tilstand",
  "enum.Step.InternalCoverTransferStep": "Intern dækningsoverførsel",
  "enum.Step.InternalTransferStep": "Intern overførelse af saldi",
  "enum.Step.InvestmentSpec": "Ændring af investeringsudløb",
  "enum.Step.InvestmentTrade": "Investeringshandel",
  "enum.Step.MoveSubPortfolio": "Flyt dækning",
  "enum.Step.NameChangeStep": "Rediger navn",
  "enum.Step.NewSubPortfolios": "Oprettet dækninger",
  "enum.Step.NoChanges": "Ansættelse uændret",
  "enum.Step.NoUpdatesToInsuredStep": "Ingen ændringer til forsikrede",
  "enum.Step.NoUpdatesToRelatedPersonStep": "Ingen opdatering til relateret person",
  "enum.Step.PartnerBirthdateChangeStep": "Rediger partners fødselsdato",
  "enum.Step.PartnerDeceasedStep": "Partner død",
  "enum.Step.PartnerNameChangeStep": "Rediger navn på partner",
  "enum.Step.PersonDeceasedStep": "Person død",
  "enum.Step.PortfolioCorrection": "Porteføljekorrektion",
  "enum.Step.PortfolioDividend": "Porteføljeudbytte",
  "enum.Step.PortfolioFundMerge": "Sammenlægning af porteføljeselskaber",
  "enum.Step.PortfolioKickback": "Portefølje-kickback",
  "enum.Step.PretendDeathStep": "Simulér død",
  "enum.Step.Rebalance": "Rebalancér",
  "enum.Step.ReconcileInvoiceStep": "Afstem faktura",
  "enum.Step.RelatedPersonDeathStep": "Relateret person død",
  "enum.Step.RelatedPersonStateParentStep": "Relateret person tilstand",
  "enum.Step.RelocationStep": "Flytning",
  "enum.Step.ResumeInvoiceStep": "Genoptag faktura",
  "enum.Step.RetirementStep": "Pensionering",
  "enum.Step.RollbackStep": "Genberegning",
  "enum.Step.SendBillingStep": "Send opkrævning",
  "enum.Step.SendReminderStep": "Send påmindelse",
  "enum.Step.SetDefaultPaymentChannelStep": "Rediger standard betalingskanal",
  "enum.Step.SetPartnerStep": "Sæt partner",
  "enum.Step.SetPersonStateStep": "Sæt personstatus",
  "enum.Step.SetPortfolioOwner": "Opret portefølje",
  "enum.Step.StartEmployerRegistrationStep": "Start firmaregistrering",
  "enum.Step.StartPartnerMigrationV3Step": "Start partnermigrering",
  "enum.Step.StartPartnerMigrationV4Step": "Start partnermigrering",
  "enum.Step.SwitchTrade": "Skift investeringsprofil",
  "enum.Step.TradeExecution": "Handel udført",
  "enum.Step.UlBalance": "Afkast fra investering",
  "enum.Step.UnitlinkConversion": "Unitlink-konvertering",
  "enum.Step.UpdateCommunicationPreferenceStep": "Opdater kommunikationspræference",
  "enum.Step.UpdateEmployment": "Ansættelseforhold opdateret",
  "enum.Step.UpdateEmploymentFromDate": "Opdater ansættelse",
  "enum.Step.UpdateNameStepApply": "Opdater navn step apply",
  "enum.Step.UpdatePartnershipStep": "Opdater partnerskab",
  "enum.Step.UpdatePointOfContactStep": "Kontaktperson opdateret",
  "enum.TradeCycleEvent.AcknowledgeTradeOrderEvent": "Handelsordre bekræftet",
  "enum.TradeCycleEvent.AggregatedTradeCycleEvent": "Handelscyklus aggregeret",
  "enum.TradeCycleEvent.ClosedTradeCycleEvent": "Handelscyklus lukket",
  "enum.TradeCycleEvent.CompletedTradeCycleEvent": "Handelscyklus afsluttet",
  "enum.TradeCycleEvent.InvestedTradeCycleEvent": "Handelscyklus investeret",
  "enum.TradeCycleEvent.ManualFixupTradeCycleEvent": "Manuel fix-up",
  "enum.TradeCycleEvent.SentTradeOrderEvent": "Handelsordre sendt",
  "enum.TradeCycleEvent.StartTradeCycleEvent": "Handelscyklus startet",
  "enum.TradeCycleEvent.TradePricesReceivedEvent": "Handelspriser modtaget",
  "enum.TradeCycleStatus.aggregated": "Aggregeret",
  "enum.TradeCycleStatus.closed": "Lukket",
  "enum.TradeCycleStatus.completed": "Afsluttet",
  "enum.TradeCycleStatus.completelyAcknowledged": "Fuldt anerkendt",
  "enum.TradeCycleStatus.completelySent": "Fuldt sendt",
  "enum.TradeCycleStatus.invested": "Investeret",
  "enum.TradeCycleStatus.partlyAcknowledged": "Delvis bekræftet",
  "enum.TradeCycleStatus.partlySent": "Handelsordre sendt",
  "enum.TradeCycleStatus.somePricesReceived": "Nogle priser modtaget",
  "enum.TradeCycleStatus.started": "Påbegyndt",
  "enum.searchEntity.company": "firma",
  "enum.searchEntity.invoice": "faktura",
  "enum.searchEntity.person": "person",
  "error.applyStop": "Stop for oprettelse af kommandoer: Kommandoer kan tilføjes, men intet kan anvendes. Hvis du forsøger at indhente det forsømte, får du en fejl.",
  "error.applyStopSimulationNotPossible": "Stop for oprettelse af kommandoer: Simulation er ikke mulig",
  "error.communicationStop": "Kommunikationsstop: Hændelsesmotoren bruger ikke dette flag, men specifikke hændelseskilder og trin kan muligvis tildele dette flag en betydning.",
  "error.errorApplyStop": "Stop for oprettelse af kommandoer pga. fejl: {reason}",
  "error.fullStop": "Fuldt stop: Ingen kommandoer kan tilføjes, og intet kan anvendes.",
  "error.validation.message": "Valideringsfejl",
  "event.helpText.viewAdvancedEventView": "Åbn avanceret visning af hændelser for at se flere hændelsesdetaljer",
  "event.helpText.viewFilter": "Vis filter",
  "event.helpText.viewGraphEventList": "Skift til grafvisning",
  "event.helpText.viewHistory": "Vis stop historik",
  "event.helpText.viewPostings": "Vis posteringer",
  "event.helpText.viewTableEventList": "Skift til tabelvisning",
  "eventBalancePostingsTable.title": "Balanceposteringer",
  "eventList.columns.after": "Efter",
  "eventList.columns.applyDate": "Ikrafttrædelse",
  "eventList.columns.before": "Før",
  "eventList.columns.expectedApplyDate": "Forventet oprettelsesdato",
  "eventList.columns.step": "Trin",
  "eventList.columns.unappliedCommand": "Ikke-tilføjet kommando",
  "eventList.columns.unappliedCommand.noCommandType": "Ingen kommandotype blev fundet",
  "eventList.columns.valueDate": "Oprettelsesdato",
  "eventList.filter.autoCommands": "Autokomandoer",
  "eventList.filter.events": "Forløb",
  "eventList.filter.scenarioCommands": "Scenarie kommandoer",
  "eventList.filter.showRecalculation": "Vis tilbagerulning",
  "eventList.title": "Hændelser",
  "eventOpenPostPostingsTable.title": "Åbne posteringer",
  "eventSelectionPostings.title": "Posteringer for valgte hændelser",
  "eventsModal.title": "Hændelser",
  "exportGlPostingsOriginalForm.component": "Komponent",
  "exportGlPostingsOriginalForm.seqNos": "Sekvensnumre",
  "exportReconciliationReportForm.component": "Komponent",
  "exportReconciliationReportForm.noSpecIdsWarning": "Ingen spec-ID'er fundet for den valgte komponent",
  "exportReconciliationReportForm.specId": "Spec-ID",
  "exportSimulationModal.action": "Eksportèr kollektive beregning simulering",
  "exportSimulationModal.title": "Eksportèr simulering",
  "externalIdChange.company.title": "Skift firmaets eksterne ID",
  "externalIdChange.newExternalId": "Nyt eksternt ID",
  "externalIdChange.person.title": "Skift personens eksterne ID",
  "externalIdChange.pseudoExternalId": "Pseudo-CPR-nummer",
  "form.missingFrame.warning": "Ikke muligt at hente eller vise valideringer. Brug med omhu",
  "frontpage.personaSwitcher": "Valg af persona",
  "frontpage.recentLinks": "Seneste søgning",
  "frontpage.welcome": "Velkommen",
  "frontpage.welcomeMessage": "Hej {name}",
  "fund.actions.addDividend": "Udbytte",
  "fund.actions.addFundMerge": "Investeringsfond - sammenlægning",
  "fund.actions.createFund": "Ny investeringsfond",
  "fund.actions.update": "Opdater investeringsfond",
  "fund.dividends": "Udbytte",
  "fund.graph.view": "Visning",
  "fund.graph.view.daily": "Daglig",
  "fund.graph.view.monthly": "Månedlig",
  "fund.graph.view.yearly": "Årlig",
  "fund.prices": "Fondspriser",
  "fund.prognosisAssetFractions": "Fordeling af investeringer",
  "fund.table.view": "Tabel visning",
  "fundCommandSelectionTable.addFund": "Tilføj fond",
  "fundCommandSelectionTable.currentCashValueFraction": "Nuværende opsparingsfordeling",
  "fundCommandSelectionTable.currentFraction": "Nuværende indbetalingsfordeling",
  "fundCommandSelectionTable.fund": "Fond",
  "fundCommandSelectionTable.fundsTableTitle": "Fonde for {profileType}",
  "fundCorrection.amount": "Beløb",
  "fundCorrection.isinKey": "Fond",
  "fundCorrection.partitionKey": "Investeringsprofil",
  "fundCorrection.units": "Enheder",
  "fundPage.commandsEmpty.informationMessage": "Ingen fund fundet for {isinKey} i selskab {tenantId}",
  "funds.fundDividend.amount": "Beløb pr. enhed",
  "funds.fundDividend.date": "Effektueringsdato",
  "funds.fundDividends.element": "Udbytte",
  "funds.fundItem": "Selskab",
  "funds.fundItem.assetManagerId": "Formueforvalter",
  "funds.fundItem.createdBy": "Oprettet af",
  "funds.fundItem.creationStamp": "Oprettelsesdato",
  "funds.fundItem.fundDividends": "Udbytte",
  "funds.fundItem.fundMerge.date": "Dato for sammenlægning",
  "funds.fundItem.fundMerge.destinationIsinKey": "Destination reference",
  "funds.fundItem.fundRiskLevel": "Risikoniveau",
  "funds.fundItem.internalCost": "ÅOP",
  "funds.fundItem.internalId": "Internt ID",
  "funds.fundItem.isinKey": "Selskab reference",
  "funds.fundItem.name": "Navn",
  "funds.fundItem.prognosisAssetFractions": "Puljefordeling",
  "funds.fundItem.shortName": "Forkortelse",
  "funds.fundItem.usageEnded": "Brug afsluttet",
  "funds.fundItems.title": "Fonde",
  "funds.fundPrices.buyPrice": "Købspris",
  "funds.fundPrices.date": "Dato",
  "funds.fundPrices.sellPrice": "Salgspris",
  "funds.fundPrices.valuePrice": "Værdipris",
  "funds.prognosisAssetFraction.element": "Investeringspulje",
  "funds.prognosisAssetFraction.fraction": "Fordeling",
  "funds.prognosisAssetFraction.prognosisAssetClass": "Investeringspuljer",
  "genderChange.button": "Kønsskifte",
  "genderChange.field.changeDate": "Ændringsdato",
  "genderChange.field.gender": "Køn",
  "groupedPayment.monthlyAmount": "Månedligt beløb",
  "groupedPayment.periodEnd": "Periode slut",
  "groupedPayment.periodStart": "Periode start",
  "hasField.commitmentVersion": "engagement version",
  "hasField.nonNegativeInvoiceAmount": "ikke-negativt opkrævningsbeløb",
  "installmentCreation.dueDate": "Forfaldsdato",
  "installmentCreation.numberOfInstallments": "Antal terminer",
  "installments.amount": "Beløb",
  "installments.dueDate": "Forfaldsdato",
  "installments.outstandingAmount": "Udestående beløb",
  "installments.title": "Afdrag",
  "internalIdInput.externalCompany": "CVR",
  "internalIdInput.externalPerson": "CPR",
  "internalIdInput.internal": "Internt ID",
  "internalIdInput.pseudoExternalPerson": "Pseudo CPR",
  "investmentSpecModalButton.title": "Ændring af investeringsudløb",
  "invoiceOperation.dueDate": "Forfaldsdato",
  "invoiceOperation.internalDueDate": "Intern forfaldsdato",
  "invoiceOperation.operationDate": "Dato",
  "invoiceOperation.operationId": "ID",
  "invoiceOperation.status": "Status",
  "invoiceOperation.status.executed": "Udført",
  "invoiceOperation.status.future": "Fremtidig",
  "invoiceOperation.terminateAction": "Afslutningshandling",
  "invoiceOperation.title": "Operationer",
  "invoicePaymentVersions.addedDate": "Registreret den",
  "invoicePaymentVersions.amount": "Beløb",
  "invoicePaymentVersions.itemName": "indbetalinger",
  "invoicePaymentVersions.paymentDate": "Betalingsdato",
  "invoicePaymentVersions.title": "Indbetalinger",
  "invoicePaymentVersions.writeOffCategory": "Afskrivningskategori",
  "invoicePaymentVersions.writeOffType": "Afskrivningstype",
  "invoiceSpecification.button": "Specifikation",
  "invoiceSpecification.title": "Specifikation",
  "invoiceTable.amount": "Beløb",
  "invoiceTable.fromDate": "Fra",
  "invoiceTable.invoiceDate": "Fakturadato",
  "invoiceTable.invoiceId": "ID",
  "invoiceTable.invoiceStatus": "Status",
  "invoiceTable.requestedDueDate": "Anmodet forfaldsdato",
  "invoiceTable.toDate": "Til",
  "invoiceVersion.billingMethodType": "Opkrævningsmetode",
  "invoiceVersion.dueDate": "Forfaldsdato",
  "invoiceVersion.installment": "Afdragsordning",
  "invoiceVersion.internalDueDate": "Intern forfaldsdato",
  "invoiceVersion.invoice": "Faktura",
  "invoiceVersion.invoiceStatus": "Status",
  "invoiceVersion.invoiceStrategyId": "Strategi",
  "invoiceVersion.netAmount": "Nettobeløb",
  "invoiceVersion.partiallyPaidAmount": "Indbetaling",
  "invoiceVersion.payerId": "Betaler-ID",
  "invoiceVersion.suspensionDate": "Suspenderingsdato",
  "invoiceVersion.suspensionReason": "Årsag",
  "invoiceVersion.totalAmount": "Totalbeløb",
  "invoicesPage.title": "Opkrævninger",
  "layout.navigation.collCalc": "Kollektive beregninger",
  "layout.navigation.funds": "Fonde",
  "layout.navigation.home": "Hjem",
  "layout.navigation.moneyInMatch": "Match",
  "layout.navigation.moneyInPayments": "Indbetalinger",
  "layout.navigation.search": "Søg",
  "layout.navigation.tradeCycles": "Handelscyklusser",
  "legalEntity.enum.ExternalPayloadType.namingResponse": "",
  "legalentity.rollbackEventModalButton.title": "Genberegning af legal entity events",
  "life.enum.CoverType.PLACEHOLDER": translationIsInCustomerLayer,
  "life.enum.ExternalPayloadType.namingResponse": "",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToAccountSpecification": "Konto",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToLegalEntitySpecification": "Personoplysninger",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToSenderSpecification": "Afsender",
  "life.rollbackEventModalButton.title": "Genberegning af engagement hændelser",
  "limitAlert.moreResults": "Der er flere resultater end de viste. Juster/tilføj flere filtre.",
  "lookupForm.info.id": "Hvis der bruges et eksternt ID til søgningen, må der ikke bruges specialtegn (-, /, _, osv.).",
  "lookupForm.input.externalOrInternalId": "Eksternt eller internt ID",
  "lookupForm.input.internalId": "Internt ID",
  "lumpsumPayments.amount": "Beløb",
  "lumpsumPayments.heading": "Engangsudbetaling",
  "lumpsumPayments.key": "Dækningsnøgle",
  "lumpsumPayments.name": "Dækningsnavn",
  "lumpsumPayments.paymentDate": "Dato",
  "lumpsumPayments.type": "Type",
  "main.tenantNotFound": "Valgte tenant kunne ikke findes",
  "markUnrelatedModal.input.unrelatedPaymentType": "Urelateret betalingsmetode",
  "markUnrelatedModal.title": "Markér som ikke relateret",
  "memberInfo.married": "Gift",
  "missingField.birthDate": "fødselsdato",
  "moneyIn.amount": "Beløb",
  "moneyIn.billingAmount": "Indbetalt præmie",
  "moneyIn.corporateSpecificationPostings.account": "Indsættelseskonto",
  "moneyIn.details.modalTitle": "Indbetalinger",
  "moneyIn.employer": "Arbejdsgiver",
  "moneyIn.enum.ExternalPayloadType.namingResponse": "",
  "moneyIn.enum.PaymentType.PLACEHOLDER": translationIsInCustomerLayer,
  "moneyIn.match.action.assignOwner": "Tildel ejer",
  "moneyIn.match.action.creditPaymentInvoice": "Kreditopkrævning",
  "moneyIn.match.action.markUnrelated": "Marker som ikke relateret",
  "moneyIn.match.action.match": "Match",
  "moneyIn.match.action.returnPayment": "Returner betaling",
  "moneyIn.match.amount": "Beløb",
  "moneyIn.match.attachInvoicePayment.accountId": "Konto-ID",
  "moneyIn.match.attachInvoicePayment.receiverId": "Modtager-ID",
  "moneyIn.match.attachInvoicePayment.returnTo": "Returner til",
  "moneyIn.match.date": "Date",
  "moneyIn.match.debt": "Udestående",
  "moneyIn.match.debtType": "Gældstype",
  "moneyIn.match.debtType.installmentPlan": "Afdragsordning",
  "moneyIn.match.debtType.invoice": "Faktura",
  "moneyIn.match.filter.amountFrom": "Min beløb",
  "moneyIn.match.filter.amountTo": "Maks beløb",
  "moneyIn.match.filter.fromDate": "Fra",
  "moneyIn.match.filter.includeClosed": "Både åbne og lukkede",
  "moneyIn.match.filter.isSuspended": "I bero",
  "moneyIn.match.filter.originalPayment": "Original betaling",
  "moneyIn.match.filter.resultLimit": "Resultatgrænse",
  "moneyIn.match.filter.resultLimit.option.noLimit": "Ingen grænse",
  "moneyIn.match.filter.toDate": "Til",
  "moneyIn.match.invoiceContainedInInstallmentPlan": "Fakturaen er en del af afdragsordningen {installmentPlanInfo}. Hvis den ikke er synlig, så prøv at justere filtrene.",
  "moneyIn.match.invoicesTab": "Fakturaer",
  "moneyIn.match.netAmount": "Nettobeløb",
  "moneyIn.match.outstandingAmount": "Resterende beløb",
  "moneyIn.match.payerId": "Betaler-ID",
  "moneyIn.match.paymentType": "Type",
  "moneyIn.match.reference": "Reference",
  "moneyIn.match.status": "Status",
  "moneyIn.match.suspendedAt": "I bero pr.",
  "moneyIn.match.title": "Betalinger",
  "moneyIn.match.totalAmount": "Totalbeløb",
  "moneyIn.matchSum.negative": "Manglende betaling {amount}",
  "moneyIn.matchSum.positive": "Overskydende betaling {amount}",
  "moneyIn.payments.amount": "Beløb",
  "moneyIn.payments.entryRef": "Posteringsreference",
  "moneyIn.payments.filter.fromDate": "Fra",
  "moneyIn.payments.filter.originalPayment": "Original betaling",
  "moneyIn.payments.filter.toDate": "Til",
  "moneyIn.payments.ownerId": "Ejer-ID",
  "moneyIn.payments.paymentDate": "Betalingsdato",
  "moneyIn.payments.paymentStatus": "Status",
  "moneyIn.payments.paymentType": "Type",
  "moneyIn.payments.reconcileInfo": "Afstemningsoplysninger",
  "moneyIn.payments.title": "Betalinger",
  "moneyIn.period": "Periode",
  "moneyIn.specificationPostings.addAllPostings": "Tilføj alle posteringer",
  "moneyIn.specificationPostings.clear": "Ryd",
  "moneyIn.specificationPostings.fetchPayments": "Hent indberetninger",
  "moneyIn.specificationPostings.noPostingError": "Ingen posteringer blev fundet. Vælg [moneyInLink] for at gå til arbejdsgiverens indbetalingsside",
  "moneyIn.specificationPostings.noPostingErrorLink": "Her",
  "moneyIn.specificationPostings.payer": "Betaler CVR",
  "moneyIn.specificationPostings.paymentFromDate": "Oprettelsesdato fra",
  "moneyIn.specificationPostings.paymentToDate": "Oprettelsesdato til",
  "moneyIn.title": "Indbetalinger",
  "moneyIn.type": "Type",
  "moneyInBundlingStopForm.bundlingStop": "Stop fakturaoprettelse",
  "moneyOut.amount": "Beløb",
  "moneyOut.cover": "Dækning",
  "moneyOut.details.modalTitle": "Udbetalinger",
  "moneyOut.enum.ExternalPayloadType.namingResponse": "",
  "moneyOut.enum.PaymentChannel.IbanPaymentChannel": "IBAN",
  "moneyOut.enum.PaymentChannel.SwiftPaymentChannel": "SWIFT",
  "moneyOut.period": "Periode",
  "moneyOut.receiver": "Modtager",
  "moneyOut.receiverPal": "SKAT",
  "moneyOut.stop.description": "Beskrivelse: ",
  "moneyOut.stop.paymentType": "Type: {paymentType}",
  "moneyOut.title": "Udbetalinger",
  "moneyOut.type": "Type",
  "moneyOutLatestHistory.title": "Seneste 10 udbetalinger",
  "nameChangeButton.button": "Navn",
  "nameChangeButton.field.changeDate": "Dato",
  "nameChangeButton.firstName": "Fornavn",
  "nameChangeButton.lastName": "Efternavn",
  "navigation.collCalc": "Kollektiv beregning",
  "navigation.datamart": "Datamart",
  "navigation.datamart2": "Datamart 2",
  "navigation.legalentity": "Juridisk enhed",
  "navigation.legalentitydatareplicator": "Datareplikator for juridiske enheder",
  "navigation.life": "Life",
  "navigation.lifedatareplicator": "Life-datareplikator",
  "navigation.moneyin": "Indbetaling",
  "navigation.moneyout": "Udbetaling",
  "navigation.unitlink": "Unitlink",
  "navigation.unitlinkdatareplicator": "Unitlink-datareplikator",
  "newCcdCalculation.title": onlyInDutchLayerForNow,
  "noRecordsFound": "Ingen poster fundet",
  "openPostPosting.column.amount": "Beløb",
  "openPostPosting.column.dim1": "Betaler",
  "openPostPosting.column.paymentDate": "Betalingsdato",
  "openPostPosting.column.reconcileNote": "Bank-ref.",
  "openPostPosting.column.valueDate": "Oprettelsesdato",
  "openPostPostingDetails.employerId": "Arbejdsgiver-ID",
  "openPostPostingDetails.valueDate": "Værdidato",
  "openPostPostingVersion.accountType": "Kontotype",
  "openPostPostingVersion.amount": "Beløb",
  "openPostPostingVersion.fromDueDate": "Fra",
  "openPostPostingVersion.limitedResultsHint": "{count} resultater vist. Der er flere resultater",
  "openPostPostingVersion.matchable": "Matchet",
  "openPostPostingVersion.postingType": "Posteringstype",
  "openPostPostingVersion.title": "Posteringer",
  "openPostPostingVersion.toDueDate": "Til",
  "openPostPostingVersion.unmatchedAmount": "Ikke-matchet beløb",
  "openPostPostingVersion.valueDate": "Valørdato",
  "openPostPostingVersion.voucher": "Bilag",
  "openPostPostings.matchable": "Matchet",
  "openPostPostings.postingType": "Posteringstype",
  "openPostPostings.unmatchedAmount": "Beløb",
  "openPostPostings.valueDate": "Værdidato",
  "option.insufficientAccessRights": "Utilstrækkelige adgangsrettigheder",
  "pageNotFound.backToHomepage": "Tilbage til startsiden",
  "pageNotFound.text": "Den side du leder efter kan ikke findes",
  "pageNotFound.title": "Ikke fundet",
  "pages.commitment.tabs.policies": "policer",
  "pages.commitment.tabs.policyEmptyReason": "Engagement er {status}",
  "pages.landing.description": "Vælg en komponent",
  "paidUpPeriod.end": "Slutdato",
  "paidUpPeriod.start": "Startdato",
  "paidUpPeriod.title": "Fripolice",
  "participantSection.ssn": "CPR",
  "partitionCommandSelectionTable.addNewPartition": "Ny partition",
  "partitionCommandSelectionTable.currentCashValueFraction": "Nuværende opsparingsprocent",
  "partitionCommandSelectionTable.currentFraction": "Nuværende indbetalingsprocent",
  "partitionCommandSelectionTable.partitionsTableTitle": "Aggregerede partitioner",
  "partitionCommandSelectionTable.profileType": "Profil type",
  "partnerCard.birthdate": "Fødselsdato",
  "partnerCard.deathDate": "Dødsfaldsdato",
  "partnerCard.endDate": "Forhold afsluttet",
  "partnerCard.partnerName": "Partner navn",
  "partnerCard.startDate": "Forhold påbegyndt",
  "partnership.endDate": "Forhold afsluttet",
  "partnership.partnerBirthdate": "Partners fødselsdato",
  "partnership.partnerDeathDate": "Partner dødsdato",
  "partnership.partnerGender": "Partner køn",
  "partnership.partnerName.firstName": "Fornavn",
  "partnership.partnerName.initials": "Initialer",
  "partnership.partnerName.lastName": "Efternavn",
  "partnership.partnerPersonId": "Partner-ID",
  "partnership.partnershipId": "Forholds-ID",
  "partnership.partnershipType": "Forholdstype",
  "partnership.startDate": "Forhold påbegyndt",
  "partnershipHistoryModal.alert.noPreviousPartners": "Ingen tidligere partnere",
  "partnershipHistoryModal.birthDate": "Fødselsdato",
  "partnershipHistoryModal.deathDate": "Dødsfaldsdato",
  "partnershipHistoryModal.endDate": "Forhold afsluttet",
  "partnershipHistoryModal.partnershipType": "Forholdstype",
  "partnershipHistoryModal.personId": "BSN",
  "partnershipHistoryModal.startDate": "Forhold påbegyndt",
  "partnershipHistoryModal.title": "Historiske forhold",
  "pauseInvoice.field.reason": "Begrundelse",
  "pauseInvoice.field.transitionTo": "Overgang til",
  "payableStops.moneyOut.modalTitle": "Stop for udbetaling",
  "payableStops.moneyOut.paymentType": "Udbetalingstype",
  "payableStops.moneyOut.stopReason": "Begrundelse for stop",
  "payableStops.moneyOut.table": "Stop for udbetaling",
  "paymentChannel.accountNumber": "Kontonummer",
  "paymentChannel.accountType": "Konto",
  "paymentChannel.bankAccount": "Konto detaljer",
  "paymentChannel.bic": "BIC",
  "paymentChannel.criteria": "Betingelser",
  "paymentChannel.currency": "Valuta",
  "paymentChannel.default": "Standard",
  "paymentChannel.ibanNumber": "IBAN",
  "paymentChannelCriterion.lifeInsuranceEvent": "Forsikringsbegivenhed",
  "paymentChannelCriterion.outgoingPaymentType": "Udbetalingstype",
  "paymentChannels.title": "Betalingskanaler",
  "paymentInfoDetails.amount": "Beløb",
  "paymentInfoDetails.entryRef": "Indgangsreference",
  "paymentInfoDetails.ownerId": "Ejer-ID",
  "paymentInfoDetails.paymentDate": "Betalingsdato",
  "paymentInfoDetails.reconcileInfo": "Afstemningsoplysninger",
  "paymentInfoDetails.splitFromPaymentId": "Splittet fra betaling",
  "paymentInfoDetails.status": "Status",
  "paymentInfoDetails.title": "Betaling",
  "paymentInfoDetails.type": "Type",
  "paymentSimulation.detailedView": "Detaljeret visning",
  "paymentSimulation.groupedMonthlyAndSinglePaymentsView": "Månedlige perioder og enkeltbetalinger",
  "paymentSimulation.title": "Udbetalinger",
  "paymentSimulation.warning": "Ikke-understøttede betalingstyper fundet, brug venligst detaljeret visning: {unsupportedPaymentTypes}",
  "paymentsIn.graph.title": "Indbetalinger for de sidste {year} år",
  "paymentsIn.notFound": "Ingen indbetalingsoplysninger fundet for denne person.",
  "paymentsIn.table.title": "Indbetalinger",
  "paymentsIn.timeline.all": "Alle",
  "paymentsIn.timeline.filtered": "Filtreret",
  "paymentsOut.graph.title": "Udbetalinger for de sidste {year} år",
  "paymentsOut.notFound": "Ingen udbetalingsoplysninger fundet for denne person.",
  "paymentsOut.table.title": "Udbetalinger",
  "paymentsOut.timeline.all": "Alle",
  "paymentsOut.timeline.filtered": "Filtreret",
  "personEntityCard.birthdate": "Fødselsdag",
  "personEntityCard.deathDate": "Dødsfaldsdato",
  "personEntityCard.initials": "Initialer",
  "personEntityCard.nationality": "Nationalitet",
  "personEntityPage.workflowActions": "Workflow-handlinger",
  "personSection.stops": "Stops",
  "personStateDataDetails.birthDate": "Fødselsdato",
  "personStateDataDetails.deathDate": "Dødsdato",
  "personStateDataDetails.personId": "Person-ID",
  "pointOfContact.button": "Kontaktoplysninger",
  "pointOfContact.enum.type.Email": "E-mail",
  "pointOfContact.enum.type.EmailVersion": "E-mail",
  "pointOfContact.enum.type.Fax": "Fax",
  "pointOfContact.enum.type.FaxVersion": "Fax",
  "pointOfContact.enum.type.Phone": "Telefon",
  "pointOfContact.enum.type.PhoneVersion": "Telefon",
  "pointOfContact.field.changeDate": "Ændringsdato",
  "pointOfContact.field.email": "E-mail",
  "pointOfContact.field.fax": "Fax",
  "pointOfContact.field.isValid": "Gyldig",
  "pointOfContact.field.phone": "Telefon",
  "pointOfContact.field.pointOfContact": "Kontaktoplysninger",
  "pointOfContact.field.pointOfContacts": "Kontaktoplysninger",
  "pointOfContact.field.type": "Type",
  "pointOfContact.field.value": "Kontaktoplysninger",
  "pointOfContact.title": "Kontaktoplysninger",
  "policiesSection.title": "Policer",
  "policyInfoCard.fromDate": "Startdato",
  "policyInfoCard.originalStartDate": "Oprindelig startdato",
  "policyInfoCard.status": "Status",
  "policyInfoCard.title": "Policeoplysninger",
  "policyInfoCard.yearlyPensionableSalary": "Pensionsgivende løn",
  "policyTabs.policiesTab": "Policedetaljer",
  "policyTabs.totalTab": "Total",
  "portfolio.actualFraction": "Aktuel fordeling",
  "portfolio.advanced.view": "Avanceret visning",
  "portfolio.allTrades": "Alle handler",
  "portfolio.amount": "Beløb",
  "portfolio.cash.fundName": "Selskabsnavn",
  "portfolio.cash.isinKey": "ISIN-nøgle",
  "portfolio.cashValue": "Kontantværdi",
  "portfolio.fund": "Fondnavn",
  "portfolio.fundCostBalance": "Investeringsrabat",
  "portfolio.fundName": "Fondnavn",
  "portfolio.history.view": "Historik visning",
  "portfolio.investmentDetails": "Investeringsdetaljer",
  "portfolio.isinKey": "ISIN",
  "portfolio.notFound": "Ingen portefølje fundet for denne person.",
  "portfolio.profileTypes": "Investeringsprofil",
  "portfolio.real": "Samlet opsparing",
  "portfolio.realWithoutYield": "Opsparing uden afkast",
  "portfolio.simple.view": "Simpel visning",
  "portfolio.statement.detailedView": "Detaljeret visning",
  "portfolio.table.actual": "Aktuel",
  "portfolio.table.aggregatedData": "Aggregeret",
  "portfolio.table.amounts": "Beløb",
  "portfolio.table.expected": "Forventet",
  "portfolio.table.fraction": "Procent",
  "portfolio.table.fundCashValuePrice": "Portefølje værdi",
  "portfolio.table.invested": "Investeret",
  "portfolio.table.subPortfolioGroupKey": "Police",
  "portfolio.table.subPortfolioKey": "Dækninger",
  "portfolio.table.sumOfUnits": "Antal enheder",
  "portfolio.table.total": "Total",
  "portfolio.table.unitPrice": "Enhedspris",
  "portfolio.table.units": "Enheder",
  "portfolio.table.wanted": "Ønsket",
  "portfolio.targetFraction": "Ønsket fordeling",
  "portfolio.trade.orders": "Handelsordrer",
  "portfolio.tradeAmount": "Beløb",
  "portfolio.tradeCostBalance": "Handelsomkostninger",
  "portfolio.tradeCycleType": "Type",
  "portfolio.tradeDate": "Dato",
  "portfolio.tradesOverview": "Handler",
  "portfolio.uninvested": "Investeringskonto",
  "portfolio.unitPrice": "Enhedspris",
  "portfolio.units": "Enheder",
  "portfolio.view.areaChart": "Områdediagram",
  "portfolio.view.days": "Dage",
  "portfolio.view.lineChart": "Linjediagram",
  "portfolio.view.months": "Måneder",
  "portfolio.view.years": "År",
  "portfolio.yield": "Afkast",
  "portfolio.yieldForCurrentYear": "Afkast for indeværende år",
  "portfolioCorrection.subPortfolioCorrection": "Vælg dækning",
  "portfolioCorrection.subPortfolioCorrections": "Dækningsniveau",
  "portfolioCorrectionModalButton.title": "Porteføljekorrektion",
  "portfolioPage.commandsEmpty.informationMessage": "Ingen portefølje fundet for {ownerId} i selskab {tenantId}",
  "portfolioTable.aggregated": "Aggregeret visning af policer",
  "postingEventCard.balanceDate": "Balancedato",
  "postingEventCard.postingAmount": "Posteringsbeløb",
  "postingEventCard.postingSequenceNo": "Posteringssekvensnr.",
  "postingEventCard.postingValueDate": "Posteringsvalørdato",
  "postings.column.accountType": "Kontotype",
  "postings.column.amount": "Beløb",
  "postings.column.companyId": "Firma-ID",
  "postings.column.coverKey": "Dækning",
  "postings.column.employerAgreementId": "Firmaaftale-ID",
  "postings.column.fromAndToDueDate": "Periode",
  "postings.column.matchable": "Matchet",
  "postings.column.moneyOutReceiver": "Modtager",
  "postings.column.policyKey": "Policenummer",
  "postings.column.postingType": "Posteringstype",
  "postings.column.seqno": "Sekvensnr",
  "postings.column.tenantId": "Selskab",
  "postings.column.tenantSubGroup": "Fund",
  "postings.column.transactionTime": "Transaktionsdato",
  "postings.column.truncated": "Migreret",
  "postings.column.valueDate": "Valørdato",
  "postings.column.voucher": "Bilag",
  "postings.column.workPadRef": "Workpad",
  "postings.receiver": "Modtager",
  "postings.sender": "Afsender",
  "postings.title": "Posteringer",
  "postings.voucher.companyId": "Firma-ID",
  "postings.voucher.creationStamp": "Oprettet kl.",
  "postings.voucher.employerAgreementId": "Firmaaftale-ID",
  "postings.voucher.id": "ID",
  "postings.voucher.lifeInsuranceEvent": "Forsikringshændelse",
  "postings.voucher.moneyOutReceiver": "Udbetalingsmodtager",
  "postings.voucher.policyKey": "Policenummer",
  "postings.voucher.policyProductType": "Police-produkttype",
  "postings.voucher.stamp": "Gemt kl.",
  "postings.voucher.title": "Posteringsbilag",
  "postings.voucher.traceId": "Spor",
  "postings.voucher.type": "Type",
  "postings.voucher.userId": "Bruger-ID",
  "premiumHolidaysPeriod.end": "Slutdato",
  "premiumHolidaysPeriod.start": "Startdato",
  "premiumHolidaysPeriod.title": "Henstand",
  "pretendDeathModalButton.deathDate": "Dødsdato",
  "pretendDeathModalButton.title": "Simulér dødsfald",
  "prognosis.deflated": "Brug faktisk ydelse",
  "recurringPayments.endDate": "Slutdato",
  "recurringPayments.heading": "Månedlige udbetalinger",
  "recurringPayments.key": "Dækningsnøgle",
  "recurringPayments.monthlyAmount": "Månedlige beløb",
  "recurringPayments.name": "Dækningsnavn",
  "recurringPayments.personName": "Modtager",
  "recurringPayments.productType": "Type",
  "recurringPayments.startDate": "Startdato",
  "relatedCommitment.name": "Navn",
  "relatedCommitment.ssn": "CPR",
  "relatedCommitment.title": "Relaterede engagementer",
  "relatedInvoices.invoiceId": "Faktura-ID",
  "relatedInvoices.originalAmount": "Oprindeligt beløb",
  "relatedInvoices.outstandingAmount": "Udestående beløb",
  "relatedInvoices.priority": "Prioritet",
  "relatedInvoices.title": "Relaterede fakturaer",
  "relationshipInfo.noPartner": "Ingen partner",
  "relationshipInfo.partnerStatus": "Partner status",
  "reset": "Nulstil",
  "resumeInvoice.field.lastOperationDate": "Seneste operation, dato",
  "resumeInvoice.field.lastOperationId": "Seneste operations-ID",
  "resumeInvoice.field.newDueDate": "Næste forfaldsdato",
  "resumeInvoice.field.nextOperationDate": "Næste operation, dato",
  "resumeInvoice.field.nextOperationId": "Næste operations-ID",
  "retirementDate.expectedRetirementDate": "Forventet pensioneringsdato",
  "retirementDate.retirementDate": "Pensioneringsdato",
  "retirementPeriod.end": "Slutdato",
  "retirementPeriod.start": "Startdato",
  "returnPayment.title": "Returner betaling",
  "riskBenefitSpecVersion.moneyOuttype": "Udbetalingstype",
  "riskBenefitSpecVersion.noBenefit": "Ingen ydelse",
  "riskCoverDetails.billingAccountBalance": "Opkrævningskontobalance",
  "riskCoverDetails.billingAccountId": "Opkrævningskonto-ID",
  "riskCoverDetails.claimAccountBalance": "Kravkontobalance",
  "riskCoverDetails.claimAccountId": "Kravkonto-ID",
  "riskCoverDetails.coInsured": "Medforsikrede",
  "riskCoverDetails.coInsuredBirthDate": "Medforsikredes fødselsdato",
  "riskCoverDetails.coInsuredDeathDate": "Medforsikredes dødsdato",
  "riskCoverDetails.coverLayerDetails": "Dækningslagsdetaljer",
  "riskCoverDetails.lifeInsuranceEvent": "Livsforsikringshændelse",
  "riskCoverDetails.relationshipId": "Forholds-ID",
  "riskCoverDetails.requiredRelationshipTypeForPayout": "Krævet forholdstype for udbetaling",
  "riskCoverDetails.riskBenefitSpecVersion": "Risikoydelsespec.",
  "riskCoverDetails.riskEndDate": "Slutdato",
  "riskCoverDetails.title": "Risikodækning",
  "riskCoverSimulation.title": "Risikodækninger",
  "rollbackForm.reason": "Begrundelse",
  "rollbackForm.rollbackTo": "Genberegning til",
  "rowAction.download": "Download",
  "rowAction.view": "Detaljer",
  "rowItem.enum.State.changed": "Ændret",
  "rowItem.enum.State.deleted": "Slettet",
  "rowItem.enum.State.new": "Ny",
  "savingsContributionSpecDetails.closedforContribution": "Lukket for indbetaling",
  "savingsContributionSpecDetails.contributionSpecFraction": "Procent",
  "savingsContributionSpecDetails.contributionSpecPriority": "Prioritet",
  "savingsCoverDetails.expectedMoneyOutStartDate": "Forventet stardato for udbetaling",
  "savingsCoverDetails.relationshipId": "Forholds-ID",
  "savingsCoverDetails.savingsAccount": "Opsparingskonto",
  "savingsCoverDetails.savingsAccountBalance": "Opsparingskontobalance",
  "savingsCoverDetails.savingsContributionSpecVersion": "Indbetalingsspec.",
  "savingsCoverDetails.savingsTaxCode": "Afkastbeskatningsform",
  "savingsCoverDetails.title": "Opsparingsdækning",
  "savingsCoverSimulation.title": "Opsparingsdækninger",
  "scenarioEventsList.noEvents": "Ingen handlinger endnu, tilføj ved at bruge kommando paletten",
  "scenarioOverview.noCommands": "Ingen kommandoer",
  "scenarioOverview.noScenariosExplainer": 'Opret et nyt scenarie ved at udføre en kommando i kommandopaletten, hvor du klikker på "{scenarioButton}" i stedet for "{applyButton}".',
  "scenarioOverview.noScenariosMatchSearch": "Ingen scenarier matcher din søgning.",
  "scenarioOverview.noVariantsAvailable": "Ingen kladder tilgængelige.",
  "scenarioOverview.scenarioCountLabel": "{count} scenarier findes",
  "scenarioOverview.searchPlaceholder": "Søg i scenarier og kladder",
  "scenarioOverview.selectedLabel": "{scenarioTitle}, {variantTitle}",
  "scenarioPage.title": "Scenarie: {scenarioTitle} / Variant: {variantTitle}",
  "scenarios.actions.addVariant": "Ny kladde",
  "scenarios.actions.apply": "Tilføj",
  "scenarios.actions.copyVariant": "Kopiér",
  "scenarios.actions.deleteScenario": "Slet scenarie",
  "scenarios.actions.deleteVariant": "Slet kladde",
  "scenarios.actions.editScenario": "Rediger scenarie",
  "scenarios.actions.editVariant": "Rediger kladde",
  "scenarios.actions.new": "Nyt scenarie",
  "scenarios.current": "Nuværende",
  "scenarios.current.diffingDisabled.noCommitment": "Diffing er deaktiveret, da deltageren ikke har et engagement.",
  "scenarios.current.selectForCompare": "Sammenlign med nuværende",
  "scenarios.leave": "Forlad scenarie",
  "scenarios.noScenario": "Ingen scenarier fundet. Opret et til højre",
  "scenarios.noScenarioSelected": "Ingen scenarievariant valgt, vælg en til højre",
  "scenarios.noVariant": "Ingen varianter fundet. Opret en til højre",
  "scenarios.simulationDate": "Simuleringsdato",
  "scenarios.title": "Scenarier",
  "scenarios.unavailableDueToStop": "Scenarier kan ikke anvendes, når engagementet er i stop",
  "search.categories.pages.agreement": "Aftale",
  "search.categories.pages.changes": "Ændringer",
  "search.categories.pages.company": "Firma",
  "search.categories.pages.health": "Helbred",
  "search.categories.pages.incomingPayment": "Indbetaling",
  "search.categories.pages.outgoingPayment": "Udbetaling",
  "search.categories.pages.person": "Person",
  "search.categories.pages.policy": "Police",
  "search.categories.pages.portfolio": "Portefølje",
  "search.categories.pages.tax": "Skatteindberetninger",
  "search.categories.recent.lastWeek": "Seneste uge",
  "search.categories.recent.older": "Ældre",
  "search.categories.recent.today": "I dag",
  "search.categories.recent.yesterday": "I går",
  "search.entityNoInformation": "Ingen oplysninger kan vises for denne {entity}. Dette kan skyldes, at den ikke eksisterer i systemet endnu. Eller at enheden muligvis er i stop.",
  "search.lookupExternalId": "Søg {id}…",
  "searchEntity.address": "Adresse",
  "searchEntity.agreements": "Aftaler",
  "searchEntity.amount": "Beløb",
  "searchEntity.birthDate": "Fødselsdato",
  "searchEntity.deathDate": "Dødsdato",
  "searchEntity.externalId": "Eksternt ID",
  "searchEntity.gender": "Køn",
  "searchEntity.internalId": "Internt ID",
  "searchEntity.lookup.allAccessDenied": "Du har ikke adgang til at se nogen af resultaterne.",
  "searchEntity.lookup.notFound": "Ingen resultater fundet",
  "searchEntity.lookup.partialAccessDenied": "Du har ikke adgang til at se alle resultaterne.",
  "searchEntity.navigate": "Naviger",
  "searchEntity.payer": "Betaler",
  "searchForm.search": "Søg",
  "searchInput.birthDate": "Fødselsdato",
  "searchInput.email": "E-mail",
  "searchInput.firstName": "Fornavn",
  "searchInput.lastName": "Efternavn",
  "searchInput.phoneNumber": "Telefonnummer",
  "searchNotFound.message": "Intet blev fundet. Prøv igen, eller forfin din søgning herunder.",
  "searchResultsCard.column.address": "Adresse",
  "searchResultsCard.column.birthDate": "Fødselsdato",
  "searchResultsCard.column.emails": "E-mails",
  "searchResultsCard.column.name": "Navn",
  "searchResultsCard.column.phoneNumbers": "Telefonnumre",
  "searchResultsCard.title": "Søgeresultater",
  "setCommitmentTime.dateTime": "Dato og tid",
  "setCommitmentTime.doNotCatchUp": "Undlad genberegning",
  "setCommitmentTime.form.warning": "Manuel indstilling af datoen vil gøre dette commitment ude af stand til at følge systemkomponentens tid!",
  "setCommitmentTime.title": "Engagementstid",
  "showInstallments.amount": "Beløb",
  "showInstallments.dueDate": "Forfaldsdato",
  "simulation.showDiffing": "Vis diffing",
  "skipAutoHandlingCommitmentSourceExternalPayloadModalButton.title": "Spring automatisk håndtering over, for ekstern engagement payload",
  "specifications.column.action.moveToExternalHandling": "Flyt til ekstern håndtering",
  "specifications.column.amount": "Beløb",
  "specifications.column.reference": "Reference",
  "specifications.column.uniqueNtryRef": "Posteringsref.",
  "specifications.column.valueDate": "Betalt",
  "status.stopped": "Stoppet",
  "stopAlert.invoiceCreation": "Fakturaoprettelse",
  "stopEvents.applicationVersion": "Applikationsversion",
  "stopEvents.applyStop": "Stop for oprettelse af kommandoer",
  "stopEvents.changedBy": "Ændret af",
  "stopEvents.communicationStop": "Kommunikationsstop",
  "stopEvents.configurationVersionNumber": "Konfigurationsversionsnummer",
  "stopEvents.creationStamp": "Oprettelses tidspunkt",
  "stopEvents.date": "Dato",
  "stopEvents.errorApplyStop": "Stop for oprettelse af kommandoer pga. fejl",
  "stopEvents.fullStop": "Fuldt stop",
  "stopEvents.reason": "Årsag",
  "stopEvents.stackTraceDetails": "Teknisk detaljer om stop årsag",
  "stopEvents.title": "Stop historik",
  "subPortfolioCorrection.amount": "Beløb",
  "subPortfolioCorrection.coverKey": "Dækninger",
  "subPortfolioCorrection.fundCorrection": "Vælg fond",
  "subPortfolioCorrection.fundCorrections": "Fondniveau",
  "subPortfolioCorrection.policyKey": "Police",
  "subPortfolioEmployment.helpText": "Visning på kundevendt police niveau",
  "subPortfolioKeyInputs.resetSubPortfolioKeys": "Nustil dækning (arv fra police)",
  "subPortfolioKeyInputs.subPortfolioGroupKey": "Effekt på policeniveau",
  "subPortfolioKeyInputs.subPortfolioKey": "Effekt på dækningsniveau",
  "switchSubPortfolioForm.subPortfolioKeys": "Dækninger til omvalg",
  "switchSubPortfolioForm.switchCommandType": "Skift kommando type",
  "switchSubPortfolioGroupForm.resetSubPortfolioKeys": "Nulstil underportefølje gruppe nøgler",
  "switchSubPortfolioGroupForm.subPortfolioGroupKeys": "Kundevendte policer til omvalg",
  "switchSubPortfolioGroupForm.switchCommandType": "Skift kommando type",
  "switchSubPortfolioGroupModalButton.title": "Skift portefølje på kundevendt police",
  "switchSubPortfolioModalButton.title": "Skift portefølje på dækning",
  "switchTradeModalButton.fundSelection": "Vælg af selskab",
  "switchTradeModalButton.fundSelection.isinKey": "ISIN-nøgle",
  "switchTradeModalButton.fundSelection.percentage": "Procent",
  "switchTradeModalButton.fundSelections": "Valg af selskaber",
  "switchTradeModalButton.profileType": "Profil type",
  "switchTradeModalButton.rebalance": "Rebalancér",
  "switchTradeModalButton.title": "Omvalg",
  "switchTradeModalButton.updateProfile": "Opdater profil",
  "timeModal.addDay": "+1 dag",
  "timeModal.addMonth": "+1 måned",
  "timeModal.addYear": "+1 år",
  "timeModal.setTime": "Sæt tid",
  "timeModal.title": "Systemtid",
  "timeline.commandLane.applyDate": "Ikrafttrædelsesdato",
  "tradeCycle.buyPrice": "Købs pris",
  "tradeCycle.cycle.amount": "Beløb",
  "tradeCycle.cycle.assetManagerId": "Asset manager-ID",
  "tradeCycle.cycle.events": "Hændelser",
  "tradeCycle.cycle.isinKey": "ISIN-nøgle",
  "tradeCycle.cycle.title": "Handelscyklus",
  "tradeCycle.cycle.type": "Type",
  "tradeCycle.cycle.units": "Enheder",
  "tradeCycle.fundName": "Portefølje navn",
  "tradeCycle.isinkey": "ISIN",
  "tradeCycle.sellPrice": "Salgs pris",
  "tradeCycle.tradeOrderStatus.acknowledged": "Godkendt",
  "tradeCycle.tradeOrderStatus.allPricesReceived": "Alle priser modtaget",
  "tradeCycle.tradeOrderStatus.assetManagerId": "Asset manager-ID",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.notReceived": "{isin} (ikke modtaget)",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.received": "{isin} (modtaget)",
  "tradeCycle.tradeOrderStatus.fundPriceStatuses": "Selskab-prisstatusser",
  "tradeCycle.tradeOrderStatus.orderId": "Ordre-ID",
  "tradeCycle.tradeOrderStatus.sent": "Sendt",
  "tradeCycle.tradePrices": "Handelspriser",
  "tradeCycleOverview.filter.fromDate": "Fra",
  "tradeCycleOverview.filter.toDate": "Til",
  "tradeCycleOverview.fromTime": "Stempel",
  "tradeCycleOverview.status": "Status",
  "tradeCycleOverview.title": "Handelscyklusser",
  "tradeCycleOverview.tradeCycleType": "Type",
  "type.enum.Address.AbroadAddress": "Udland",
  "type.enum.Address.Address": "Adresse",
  "type.enum.Address.InformalAddress": "Uformel",
  "unitLink.enum.ExternalPayloadType.namingResponse": "",
  "unitlinkCoverVoucher.amount": "Beløb",
  "unitlinkCoverVoucher.coverKey": "Dækning",
  "unitlinkCoverVoucher.policyKey": "Policenummer",
  "unitlinkCoverVoucher.profileType": "Profiltype",
  "update": "Opdater",
  "updateBalance.calculationDate": "Beregningsdato",
  "updateBalance.description": "Dette vil beregne og opdatere unitlink balance for denne portfolio på beregningsdatoen.",
  "updateBalance.title": "Balance opdatering for alle policer",
  "updateCommitmentSourceExternalPayloadModalButton.postingId": "Postering",
  "updateCommitmentSourceExternalPayloadModalButton.title": "Opdater ekstern payload for engagement",
  "updateCommunicationPreference.field.changeDate": "Ændringsdato",
  "updateCommunicationPreference.field.communicationPreferenceType": "Kommunikationspræference",
  "updateCommunicationPreference.title": "Kommunikationspræference",
  "updateCompanyName.button": "Firmanavn",
  "updateCompanyName.name": "Navn",
  "updatePartnerButton.buttonAdd": "Partner",
  "updatePartnerButton.buttonUpdate": "Partner opdatering",
  "updatePartnerButton.changeDate": "Ændringsdato",
  "uploadHistoricalInputsModal.action": "Upload historisk input",
  "userSettings.enum.theme.dark": "Mørk",
  "userSettings.enum.theme.light": "Lys",
  "userSettings.enum.theme.system": "System",
  "userSettings.user": "Bruger",
  "validation.companyId": "CVR kunne ikke findes",
  "validation.enabled": "Valider formularen",
  "validation.ssn": "CPR kunne ikke findes",
  "validationMessage.overrideButtonText": "Overstyr",
  "validationMessage.overrideMessage": "Accept besked",
  "validationOverridesInEffect.key": "Validering",
  "validationOverridesInEffect.reason": "Accept besked",
  "validationOverridesInEffect.title": "Accepterede valideringer",
  "viewPaymentModal.invoiceId": "Faktura-ID",
  "viewPaymentModal.paymentType.ReturnedPayment": "Returneret betaling",
  "viewPaymentModal.paymentType.invoicePayment": "Faktura betaling",
  "viewPaymentModal.paymentType.settledPayment": "Afregnet betaling",
  "viewPaymentModal.paymentType.splitPayment": "Splittet betaling",
  "viewPaymentModal.paymentUsage": "Brug",
  "viewPaymentModal.paymentUsageType": "Brugstype",
  "viewPaymentModal.settledWithPaymentId": "Afregnet med betalings-ID",
  "viewPaymentModal.splitToPaymentIds": "Opdelt betaling",
  "viewPaymentModal.userId": "Bruger-ID",
  "workPad.creationStamp": "Oprettet kl.",
  "workPad.title": "Workpad",
  "workPad.userId": "Oprettet af",
})
